(function() {
  "use strict";

  angular.module("app.branch", []).config(config);

  /** @ngInject */
  function config($stateProvider) {
    // State
    $stateProvider
      .state("app.branchList", {
        abstract: true,
        views: {
          "main@": {
            templateUrl: "app/core/layouts/content-with-toolbar.html",
            controller: "MainController as vm"
          },
          "toolbar@app.branchList": {
            templateUrl: "app/toolbar/toolbarWithLogo.html",
            controller: "ToolbarController as vm"
          }
        },
        resolve: {
          currentAuth: function() {
            return firebaseHelper.requireSignIn(true);
          }
        }
      })


      .state("app.branchList.branchs", {
        url: "/branchs",
        views: {
          "content@app.branchList": {
            templateUrl: "app/main/branchList/branchList.html",
            controller: "BranchListController as vm"
          }
        }
      })


      .state("app.branch", {
        abstract: true,
        url: "/branch/:branchId",
        views: {
          "main@": {
            templateUrl: "app/core/layouts/content-only.html",
            controller: "BranchController as vm"
          },
          // "toolbar@app.branch": {
          //   templateUrl: "app/toolbar/toolbarWithLogo.html",
          //   controller: "ToolbarController as vm"
          // }
        },
        resolve: {
          currentAuth: function() {
            return firebaseHelper.requireSignIn(true);
          }
        }
      })

      .state("app.branch.orders", {
        url: "/orders",
        views: {
          "content@app.branch": {
            templateUrl: "app/main/branchOrders/branchOrders.html",
            controller: "BranchOrdersController as vm"
          }
        }
      })
      .state("app.branch.orderDetail", {
        url: "/order/:orderId",
        views: {
          "content@app.branch": {
            templateUrl: "app/main/branchOrderDetails/branchOrderDetails.html",
            controller: "BranchOrderDetailsController as vm"
          }
        }
      });
  }
})();

(function() {
  "use strict";

  angular
    .module("app.branch")
    .controller("RejectOrderDialogController", RejectOrderDialogController);

  /** @ngInject */
  function RejectOrderDialogController(
    $mdDialog,
    orderId,
    order,
    isApproveOrRefuseProcessing,
    afterRefuse,
    ngProgressFactory,
    $mdToast,
    $timeout,
    $rootScope,
    api
  ) {
    var vm = this;

    vm.rejectOrderForm;
    vm.rejectObj = {};
    vm.orderId = orderId;
    vm.order = order;
    vm.isApproveOrRefuseProcessing = isApproveOrRefuseProcessing;
    vm.reasons = ORDER_REJECT_REASONS;
    vm.progressbar = ngProgressFactory.createInstance();

    vm.rejectButtonAction = rejectButtonAction;
    vm.closeDialog = closeDialog;

    function rejectButtonAction(rejectObj) {
      rejectAction(rejectObj);
    }
    /**
		 * Close dialog
		 */
    function closeDialog() {
      $mdDialog.hide();
    }

    function rejectAction(rejectObj) {
      vm.isLoading = true;
      vm.isApproveOrRefuseProcessing = true;
      if (!rejectObj.reason) {
        rejectObj.reason = "";
      }
      rejectObj.orderId = vm.orderId;
      vm.progressbar.start();

      api
        .refuseOrder(rejectObj)
        .then(function(result) {
          console.log(result);
          $timeout(function() {
            vm.order.currentStatus = ORDER_STATUSES.REFUSED.code;
            vm.isApproveOrRefuseProcessing = false;
            vm.progressbar.complete();
            showToast("Reddedildi");
            afterRefuse();
            vm.isLoading = false;
            alert("Müşteriye sipariş reddedildi email'i gönderildi.");
            alert("Ayarıca müşterinizi aramanızı ve iptal edildiği bilgisini vermenizi şiddettle öneririz.");
            closeDialog();
          });
        })
        .catch(function(err) {
          console.log(err);
          $timeout(function() {
            vm.isApproveOrRefuseProcessing = false;
            alert("Bir hata oluştu! Tekrar deneyin.");
            vm.progressbar.complete();
            vm.isLoading = false;
          });
        });
    }

    function showToast(msg) {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent(msg)
          .position("top right")
          .hideDelay(3000)
      );
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("app.branch")
    .controller("ApproveOrderDialogController", ApproveOrderDialogController);

  /** @ngInject */
  function ApproveOrderDialogController(
    $mdDialog,
    $timeout,
    approveOrderCallbackFunction,
    order
  ) {
    var vm = this;
    vm.closeDialog = closeDialog;
    vm.approve = approve;

    function approve(mins) {
      approveOrderCallbackFunction(order, mins);
      $timeout(function () {
        closeDialog();
      });
    }

    function closeDialog() {
      $mdDialog.hide();
    }



  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.login', {
            url      : '/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

    }

})();
(function() {
  "use strict";

  angular
    .module("app.login")
    .controller("EmailLoginDialogController", EmailLoginDialogController);

  /** @ngInject */
  function EmailLoginDialogController($mdDialog, $timeout, $state) {
    var vm = this;
    vm.form = {};
    vm.error = false;
    vm.isLoading = false;

    // Methods
    vm.closeDialog = closeDialog;
    vm.login = login;

    /**
		 * Close dialog
		 */
    function closeDialog() {
      $mdDialog.hide();
    }

    function login() {
      $timeout(function() {
        vm.isLoading = true;
        vm.error = false;
      });
      $timeout(function() {
        firebaseHelper
          .loginWithEmailPassword(vm.form)
          .then(function(result) {
            $timeout(function() {
              $state.go("app.index");
              vm.isLoading = false;
              closeDialog();
            });
          })
          .catch(function(error) {
            $timeout(function() {
              vm.isLoading = false;
              console.log(error);
              if (authErrors[error.code]) {
                vm.error = authErrors[error.code];
              } else {
                vm.error = error.message;
              }
            });
          });
      }, 2000);
    }
  }
})();

(function() {
	'use strict';

	angular
		.module('app.branch')
		.controller('ShowHtmlDialogController', ShowHtmlDialogController);

	/** @ngInject */
	function ShowHtmlDialogController($mdDialog, html, title) {
		var vm = this;

		vm.html = html;
		vm.title = title;
		vm.closeDialog = closeDialog;

		/**
		 * Close dialog
		 */
		function closeDialog() {
			$mdDialog.hide();
		}

	}
})();

(function() {
	'use strict';

	angular
		.module('app.login')
		.controller('PasswordUpdateDialogController', PasswordUpdateDialogController);

	/** @ngInject */
	function PasswordUpdateDialogController($mdDialog, $timeout) {
		var vm = this;

		vm.form = {};
		vm.error = false;
		vm.isLoading = false;
		vm.updatePassword = updatePassword;

		vm.closeDialog = closeDialog;


		function updatePassword() {
			if(vm.form.password !== vm.form.password2){
				alert("Şifreler uyuşmuyor")
				return;
			}
			$timeout(function() {
				vm.isLoading = true;
				vm.error = null;
			});

      globalFirebaseUser.updatePassword(vm.form.password)
				.then(function() {
					closeDialog();
					$timeout(function() {
						vm.isLoading = false;
					});
					alert('Şifre kaydedildi!');
				}).catch(function(error) {
					console.error(error);
					$timeout(function() {
						vm.isLoading = false;
						if (authErrors[error.code]) {
							vm.error = authErrors[error.code];
						} else {
							vm.error = error.message;
						}
					});
				});
		}
		/**
		 * Close dialog
		 */
		function closeDialog() {
			$mdDialog.hide();
    }

	}
})();

(function() {
  "use strict";

  angular
    .module("app.login")
    .controller(
      "NotificationSettingsDialogController",
      NotificationSettingsDialogController
    );

  /** @ngInject */
  function NotificationSettingsDialogController(
    $mdDialog,
    branchId,
    smallBranchObj,
    apiAdmin,
    $timeout,
    $mdToast
  ) {
    var vm = this;
    vm.isLoading = true;
    vm.closeDialog = closeDialog;
    function closeDialog() {
      $mdDialog.hide();
    }

    vm.globalAudioObj = globalAudioObj;
    vm.onSoundOptionChanged = onSoundOptionChanged;
    vm.smallBranchObj = smallBranchObj;
    vm.phoneNumbers = {};
    vm.smsNumbers = {};
    vm.phoneFormModel = {};
    vm.smsFormModel = {};
    vm.soundOption = "0";
    if(localStorage.hasOwnProperty("ORDER_SOUND_NUM")){
      vm.soundOption = localStorage.getItem("ORDER_SOUND_NUM");
    }

    vm.audio;

    vm.playNotification = playNotification;
    vm.addSmsNumber = addSmsNumber;
    vm.addPhoneNumber = addPhoneNumber;
    vm.deleteSmsNumber = deleteSmsNumber;
    vm.deletePhoneNumber = deletePhoneNumber;
    vm.showDeletePrimaryWarning = showDeletePrimaryWarning;
    vm.onMobileNotificationChanged = onMobileNotificationChanged;


    function onSoundOptionChanged(key) {
      console.log("onSoundOptionChanged key:")
      console.log(key);

      if(key === "0"){
        localStorage.removeItem("ORDER_SOUND_NUM");
        try {
          document.getElementById("gelen").play();
          globalAudio.play();
        } catch (e) {
          console.log(e);
        }
        showToast("Sipariş bildirim sesi zil olarak ayarlandı. Duymak için sesi artırmalısınız.");
      }else{
        localStorage.setItem("ORDER_SOUND_NUM", key);
        try {
          document.getElementById("gelen"+key).play();
          globalAudioObj[key].play();
        } catch (e) {
          console.log(e);
        }
        showToast("Sipariş bildirim sesi  " + key + " olarak ayarlandı. Duymak için sesi artırmalısınız.");
      }


    }

    function onMobileNotificationChanged(expoTokenObj_isSubscribed) {
      if(!EMBED_EXPO_PUSH_TOKEN_CODE){
        alert("Bir hata oluştu. Bildirimlere telefonunuzun ayarlardan izin vermeniz gerekiyor. Uygulama yeniden başlatılacak");
        window.location.reload();
        return;
      }

      $timeout(function() {
        vm.isLoading = true;
      });
      if (expoTokenObj_isSubscribed === false) {
        apiAdmin
          .unsubscribeToBranch({
            branchId: branchId,
            embedExpoPushTokenCode: EMBED_EXPO_PUSH_TOKEN_CODE
          })
          .then(function(result) {
            console.log("apiAdmin.unsubscribeToBranch");
            console.log(result);
            localStorage.setItem(
              EMBED_EXPO_PUSH_TOKEN_CODE +
                "_" +
                branchId +
                "_DO_NOT_AUTO_SUBSCRIBE",
              "1"
            );
            getBranchNotifications();
          });
      }else{
        apiAdmin
          .subscribeToBranch({
            branchId: branchId,
            embedExpoPushTokenCode: EMBED_EXPO_PUSH_TOKEN_CODE,
            autoSubscribe: false
          })
          .then(function(result) {
            localStorage.removeItem(
              EMBED_EXPO_PUSH_TOKEN_CODE +
                "_" +
                branchId +
                "_DO_NOT_AUTO_SUBSCRIBE"
            );

            localStorage.setItem(
              EMBED_EXPO_PUSH_TOKEN_CODE +
                "_" +
                branchId +
                "_AUTO_SUBSCRIBED",
                "1"
            );
            getBranchNotifications();
          });
      }
    }

    function deletePhoneNumber(number) {
      deleteNumber("phone", number);
    }

    function deleteSmsNumber(number) {
      deleteNumber("sms", number);
    }

    function addPhoneNumber() {
      addNew("phone", vm.phoneFormModel.phoneNumber);
    }

    function addSmsNumber() {
      addNew("sms", vm.smsFormModel.smsNumber);
    }

    function showDeletePrimaryWarning() {
      alert(
        "Bu numara yönetici tarafından değiştirilebilir. Yönetici kurulum sayfası olan kurulum.hadiyemek.com'a giderek bu numarayı değiştirebilir."
      );
    }

    function getBranchNotifications() {
      vm.isLoading = true;
      var reqObj = {
        branchId: branchId
      };
      if (EMBED_EXPO_PUSH_TOKEN_CODE) {
        reqObj.embedExpoPushTokenCode = EMBED_EXPO_PUSH_TOKEN_CODE;
      }
      apiAdmin.getBranchNotifications(reqObj).then(function(result) {
        console.log(result);
        $timeout(function() {
          vm.isLoading = false;
          vm.phoneNumbers = result.data.phoneNumbers;
          vm.smsNumbers = result.data.smsNumbers;
          vm.primarySms = result.data.primarySms;
          vm.primaryNumber = result.data.primaryNumber;
          vm.expoTokenObj = result.data.expoTokenObj
            ? result.data.expoTokenObj
            : {isSubscribed:false};
          vm.phoneFormModel = {};
          vm.smsFormModel = {};
          vm.isPhoneInputVisible = false;
          vm.isSmsInputVisible = false;
        });
      });
    }

    function showToast(msg) {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent(msg)
          .position("top right")
          .hideDelay(3000)
      );
    }

    function playNotification() {
      showToast("Ses duymuyorsanız ses ayarlarınızı kontrol ediniz");
      if (!vm.audio) {
        vm.audio = new Audio(
          "https://kurulum.hadiyemek.com/assets/audio/hadiyemek-siparis-var.mp3"
        );
      }
      if (vm.audio.paused) {
        vm.isAudioPlaying = true;
        try {
          vm.audio.play();
        } catch (e) {
          console.log(e);
        }
      } else {
        vm.isAudioPlaying = false;
        try {
          vm.audio.pause();
        } catch (e) {
          console.log(e);
        }
        vm.audio.currentTime = 0;
      }
    }

    function deleteNumber(type, number) {
      if (confirm("Numarayi silmek istediğinize emin misiniz?")) {
        vm.isLoading = true;
        apiAdmin
          .deleteBranchNotifications({
            type: type,
            branchId: branchId,
            number: number
          })
          .then(function(result) {
            console.log(result);
            $timeout(function() {
              getBranchNotifications();
            });
          });
      }
    }

    function addNew(type, number) {
      if (type === "phone") {
        if (!isValidPhoneNumber(number)) {
          alert(
            "Girmiş olduğunuz numara: " +
            number +
            " başında 0 olmamalı ve 10 haneli olmalıdır."
          );
          return;
        }
      } else if (type === "sms") {
        if (!isValidMobileNumber(number)) {
          alert(
            "Girmiş olduğunuz numara: " +
            number +
            ", 5 ile başlamalı ve 10 haneli olmalıdır."
          );
          return;
        }
      }

      vm.isLoading = true;
      apiAdmin
        .addBranchNotifications({
          type: type,
          branchId: branchId,
          number: number
        })
        .then(function(result) {
          console.log(result);
          $timeout(function() {
            getBranchNotifications();
          });
        });
    }

    function init() {
      getBranchNotifications();
    }

    init();
  }
})();

(function() {
  "use strict";

  angular
    .module("app.login")
    .controller(
      "NotificationMobileSettingsDialogController",
      NotificationMobileSettingsDialogController
    );

  /** @ngInject */
  function NotificationMobileSettingsDialogController(
    $mdDialog,
    $mdToast,
    $timeout,
    apiAdmin
  ) {
    var vm = this;
    vm.isLoading = true;
    vm.closeDialog = closeDialog;
    function closeDialog() {
      $mdDialog.hide();
    }
    vm.branchsNotificationList = {};

    vm.onNotificationChanged = onNotificationChanged;

    function onNotificationChanged(branchId, branchNotification) {
      if (!EMBED_EXPO_PUSH_TOKEN_CODE) {
        alert(
          "Bir hata oluştu. Bildirimlere telefonunuzun ayarlardan izin vermeniz gerekiyor. Uygulama yeniden başlatılacak"
        );
        window.location.reload();
        return;
      }

      $timeout(function() {
        vm.isLoading = true;
      });
      if (branchNotification.isSubscribed === false) {
        apiAdmin
          .unsubscribeToBranch({
            branchId: branchId,
            embedExpoPushTokenCode: EMBED_EXPO_PUSH_TOKEN_CODE
          })
          .then(function(result) {
            console.log("apiAdmin.unsubscribeToBranch");
            console.log(result);
            localStorage.setItem(
              EMBED_EXPO_PUSH_TOKEN_CODE +
                "_" +
                branchId +
                "_DO_NOT_AUTO_SUBSCRIBE",
              "1"
            );
            init();
          })
          .catch(function(errorData) {
            console.log("errorData");
            console.log(errorData);
            if (
              errorData &&
              errorData.data &&
              errorData.data.error &&
              errorData.data.error.type &&
              errorData.data.error.type == "knownErrors"
            ) {
              alert(errorData.data.error.message);
            } else {
              alert("Bilinmeyen hata! Lütfen tekrar deneyiniz.");
            }
            init();
          });
      } else {
        apiAdmin
          .subscribeToBranch({
            branchId: branchId,
            embedExpoPushTokenCode: EMBED_EXPO_PUSH_TOKEN_CODE,
            autoSubscribe: false
          })
          .then(function(result) {
            localStorage.removeItem(
              EMBED_EXPO_PUSH_TOKEN_CODE +
                "_" +
                branchId +
                "_DO_NOT_AUTO_SUBSCRIBE"
            );

            localStorage.setItem(
              EMBED_EXPO_PUSH_TOKEN_CODE + "_" + branchId + "_AUTO_SUBSCRIBED",
              "1"
            );
            init();
          });
      }
    }

    function showToast(msg) {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent(msg)
          .position("top right")
          .hideDelay(3000)
      );
    }

    function init() {
      vm.isLoading = true;
      if (!EMBED_EXPO_PUSH_TOKEN_CODE) {
        alert(
          "Bir hata oluştu. Bildirimlere telefonunuzun ayarlardan izin vermeniz gerekiyor. Uygulama yeniden başlatılacak"
        );
        window.location.reload();
        return;
      }
      apiAdmin
        .getAllBranchSubscriptions({
          embedExpoPushTokenCode: EMBED_EXPO_PUSH_TOKEN_CODE
        })
        .then(function(result) {
          $timeout(function() {
            vm.isLoading = false;
            console.log(result);
            vm.branchsNotificationList = result.data.branchs;
          });
        });
    }

    init();
  }
})();

(function() {
  "use strict";

  angular
    .module("app.branch")
    .controller("LoadingDialogController", LoadingDialogController);

  /** @ngInject */
  function LoadingDialogController(
  ) {
    var vm = this;
  }
})();

(function() {
	"use strict";

	angular
		.module("app.branch")
		.controller("BranchAutoPrintSettingsDialogController", BranchAutoPrintSettingsDialogController);

	/** @ngInject */
	function BranchAutoPrintSettingsDialogController(
		branch,
		$mdDialog,
		$timeout
	) {
		var vm = this;
		vm.closeDialog = function() {
			$mdDialog.hide();
		};

		vm.printerSettingsForm;
		vm.branch = branch;
		vm.printers;
		vm.isLoading = true;

		vm.save = save;

		var currentUser = global.firebaseUser;
		if (!global.autoprintSettings.users) {
			global.autoprintSettings.users = {};
		}
		if (!global.autoprintSettings.users[currentUser.uid]) {
			global.autoprintSettings.users[currentUser.uid] = {};
		}
		if (!global.autoprintSettings.users[currentUser.uid].branchs) {
			global.autoprintSettings.users[currentUser.uid].branchs = {};
		}

		vm.paperTypes = {
			"Adisyon": "Adisyon",
			"A4Paper": "A-4",
			"A5Paper": "A-5",
		}

		vm.fontTypes = {
			"BIG_FONT": "Büyük Yazı Boyutu",
			"small_font": "Küçük Yazı Boyutu",
		}

		vm.onNumberOfCopiesChanged = function (val) {
			var valNumber = parseInt(val);
			if(isNaN(valNumber)){
				vm.branchSettings.numberOfCopies = 1
			}else if(valNumber < 0){
				vm.branchSettings.numberOfCopies = 1
			}
		}

		vm.branchSettings = global.autoprintSettings.users[currentUser.uid].branchs[vm.branch.branchKey] || {
			enabled: false,
			branchData: vm.branch,
			paperType: "Adisyon",
			playSound: false,
			numberOfCopies: 1,
		};

		function save() {
			global.autoprintSettings.users[currentUser.uid].branchs[vm.branch.branchKey] = vm.branchSettings;
			$timeout(function() {
				vm.isLoading = true;
			});
			global.util.saveAutoprintSettings(function() {
				$timeout(function() {
					global.util.showNotification('Otomatik Yazdırma', 'Ayarlar kaydedildi');
					vm.isLoading = false;
					vm.closeDialog();
				});
			});
		}

		var win = nw.Window.get();
		win.getPrinters(function(result) {
			console.log("orginal result");
			console.log(result);
			if (window.location.href.indexOf("localhost.com") !== -1) {
				result = [{
					"deviceName": "Print to PDF (Mac Desktop)",
					"printerDescription": "",
					"printerName": "Print to PDF (Mac Desktop)",
					"printerOptions": {
						"printer-location": "",
						"printer-make-and-model": "HP Color LaserJet 8500 PS",
						"system_driverinfo": "HP Color LaserJet 8500 PS;6.0.6000.16386 (vista_rtm.061101-2205);Microsoft® Windows® Operating System;6.0.6000.16386"
					}
				}];
				console.log("result override by result obj:", result);
			}
			vm.printers = result;
			$timeout(function() {
				vm.isLoading = false;
				if (vm.printers.length > 0 && !vm.branchSettings.printerDeviceName) {
					vm.branchSettings.printerDeviceName = vm.printers[0].deviceName;
				}
			});
		});

		$timeout(function() {
			if (!vm.branchSettings.paperType) {
				vm.branchSettings.paperType = "Adisyon";
			}
			if (!vm.branchSettings.font) {
				vm.branchSettings.font = "small_font";
			}
			if (vm.branchSettings.playSound !== true) {
				vm.branchSettings.playSound = false;
			}
			if (vm.branchSettings.numberOfCopies === undefined) {
				vm.branchSettings.numberOfCopies = 1;
			}
			if (vm.branchSettings.numberOfCopies === null) {
				vm.branchSettings.numberOfCopies = 1;
			}
		});
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('ANGULARHADIYEMEK.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('ANGULARHADIYEMEK.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('ANGULARHADIYEMEK.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {

        // Methods
        this.config = function(){};

        this.$get = function ()
        {

            return {};

        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, angularhadiyemekConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    // var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    // if ( iAttrs.msScroll )
                    // {
                    //     options = scope.$eval(iAttrs.msScroll);
                    // }

                    // // Extend the given config with the ones from provider
                    // options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // // Initialize the scrollbar
                    // $timeout(function ()
                    // {
                    //     PerfectScrollbar.initialize(iElement[0], options);
                    // }, 0);

                    // // Update the scrollbar on element mouseenter
                    // iElement.on('mouseenter', updateScrollbar);

                    // // Watch scrollHeight and update
                    // // the scrollbar if it changes
                    // scope.$watch(function ()
                    // {
                    //     return iElement.prop('scrollHeight');
                    // }, function (current, old)
                    // {
                    //     if ( angular.isUndefined(current) || angular.equals(current, old) )
                    //     {
                    //         return;
                    //     }

                    //     updateScrollbar();
                    // });

                    // // Watch scrollWidth and update
                    // // the scrollbar if it changes
                    // scope.$watch(function ()
                    // {
                    //     return iElement.prop('scrollWidth');
                    // }, function (current, old)
                    // {
                    //     if ( angular.isUndefined(current) || angular.equals(current, old) )
                    //     {
                    //         return;
                    //     }

                    //     updateScrollbar();
                    // });

                    // /**
                    //  * Update the scrollbar
                    //  */
                    // function updateScrollbar()
                    // {
                    //     PerfectScrollbar.update(iElement[0]);
                    // }

                    // // Cleanup on destroy
                    // scope.$on('$destroy', function ()
                    // {
                    //     iElement.off('mouseenter');
                    //     PerfectScrollbar.destroy(iElement[0]);
                    // });
                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.updateItem = updateItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         */
        function updateItem(path, newKey, newValue)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            //item.splice(i, 1);
                            item[i][newKey] =  newValue;
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                updateItem        : updateItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, angularhadiyemekGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: angularhadiyemekGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: angularhadiyemekGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function() {
	'use strict';

	angular
		.module('app.login')
		.controller('LoginController', LoginController);

	/** @ngInject */
	function LoginController($timeout, api, $state, $mdDialog) {
    console.log('LoginController');
		var vm = this;
		vm.form = {};
		vm.error = false;

		vm.isLoading = false;
		vm.isSmsPasswordInputVisible = false;

		// Methods
		vm.sendMeVerificationCode = sendMeVerificationCode;
		vm.openEmailLoginModal = openEmailLoginModal;
		vm.verifySmsCode = verifySmsCode;

		firebase.auth().onAuthStateChanged(function(user) {
			if (user) {
				$state.go('app.index');
			}
		});

		$timeout(function(){
			if (localStorage.hasOwnProperty("LATEST_PHONE_NUMBER")) {
				vm.form.mobilePhone = localStorage.getItem("LATEST_PHONE_NUMBER");
				if(vm.loginForm){
					vm.loginForm.$pristine = false;
				}
			}
		}, 1000);

		//////////

		function sendMeVerificationCode() {
			$timeout(function() {
				vm.isLoading = true;
				vm.error = false;
			});
			try {
				localStorage.setItem("LATEST_PHONE_NUMBER", vm.form.mobilePhone);
			}
			catch(err) {
				console.log(err);
			}
			api.sendMeVerificationCode({
				"number": vm.form.mobilePhone
			}).then(function(result) {

				$timeout(function() {
					vm.isLoading = false;
					vm.isSmsPasswordInputVisible = true;
					setTimeout(function() {
						document.getElementById('smsPasswordInput').focus();
					}, 100);
				});

			}).catch(function(errorData) {

				$timeout(function() {
					console.log(errorData);
					vm.isLoading = false;
					if (errorData.data.error.type && errorData.data.error.type == "knownErrors") {
						vm.error = errorData.data.error.message;
					} else {
						vm.error = "Bilinmeyen bir hata oldu. Lütfen tekrar deneyin";
					}
				});

			});
		}

		function verifySmsCode() {

			$timeout(function() {
				vm.isLoading = true;
				vm.error = false;
			});

			api.verifySmsCode({
				"number": vm.form.mobilePhone,
				"smsPassword": vm.form.smsPassword,
				"action": "login"
			}).then(function(result) {

				console.log("result:", result);
				if (result.data.isValid) {
					firebaseHelper.signInWithCustomToken(result.data.token)
						.then(function() {
							$state.go('app.index');
							$timeout(function() {
								vm.isLoading = false;
								vm.isSmsPasswordInputVisible = true;
							}, 1000);
						})
				} else {
					global.util.showNotification('Otomatik Yazdırma', "Bir hata oluştu!");
					$timeout(function() {
						vm.isLoading = false;
						vm.isSmsPasswordInputVisible = true;
					});
				}



			}).catch(function(errorData) {
				$timeout(function() {
					vm.isSmsPasswordInputVisible = true;
					console.log(errorData);
					vm.isLoading = false;
					if (errorData.data.error.type && errorData.data.error.type == "knownErrors") {
						vm.error = errorData.data.error.message;
					} else {
						vm.error = "Bilinmeyen bir hata oldu. Lütfen tekrar deneyin";
					}
				});

			});
    }


    function openEmailLoginModal(ev) {
      $mdDialog.show({
        controller: "EmailLoginDialogController",
        controllerAs: "vm",
        templateUrl: "app/main/login/email-login-dialog/email-login-dialog.html",
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {}
      });
    }

	}
})();

var isSetTrueBeforeAutocallLead = false;
(function() {
	"use strict";

	angular
		.module("app.branch")
		.controller("BranchOrdersController", BranchOrdersController);

	/** @ngInject */
	function BranchOrdersController(
		$scope,
		$timeout,
		$stateParams,
		$state,
		ngProgressFactory,
		api,
		$mdDialog,
		$rootScope,
		$mdToast,
		apiAdmin
	) {

		var vm = this;

		$rootScope.isSuperAdmin = isSuperAdmin;

		function isSuperAdmin() {
			// if (!globalFirebaseUser) {
			// 	return false;
			// } else {
			// 	return globalFirebaseUser.uid === "QyKAwUxuhGXOtl49Opajp4KVeCJ3";
			// }
			return false;
		}

		vm.isLoading = true;
		vm.orders = {};
		vm.smallBranchObj = {};
		vm.currentOrders = {};
		vm.finishedOrders = {};

		vm.progressbar = ngProgressFactory.createInstance();
		vm.branchId = $stateParams.branchId;
		vm.masterStatus;
		vm.branchStatus;

		vm.printViaDefaultPrinter = printViaDefaultPrinter;
		vm.setStatusOnWay = setStatusOnWay;
		vm.setStatusDone = setStatusDone;

		vm.refuseOrder = refuseOrder;
		vm.approveOrder = approveOrder;
		vm.isApproveOrRefuseProcessing = false;

		vm.createTestOrder = createTestOrder;

		vm.showNotificationSettings = showNotificationSettings;

		vm.setMasterStatusClose = setMasterStatusClose;
		vm.setMasterStatusOpen = setMasterStatusOpen;
		vm.setStatusOpen = setStatusOpen;
		vm.setStatusClosed = setStatusClosed;
		vm.setStatusBusy = setStatusBusy;
		vm.openOrderDetail = openOrderDetail;

		function printViaDefaultPrinter(order) {
			var currentUser = global.firebaseUser;
			var branchSettings = global.autoprintSettings.users[currentUser.uid].branchs[vm.branchId];
			console.log("branchSettings");
			console.log(branchSettings);

			var paperType = "Adisyon";
			var font = "small_font";
			if(branchSettings && branchSettings.paperType){
				paperType = branchSettings.paperType;
			}
			if(branchSettings && branchSettings.font){
				font = branchSettings.font;
			}

			global.orderWindowHelpers.printOrder(vm.branchId, order.orderKey, paperType, font);
		}

		function openOrderDetail(order) {
			// var params = {
			// 	orderId: order.orderKey
			// };
			// var url = global.webOrigin + $state.href('app.branch.orderDetail', params);
			var url = global.webOrigin + '/nwjsStart/orderDetails/orderDetails.html?branch=' + vm.branchId + '&order=' + order.orderKey + "&paperType=Adisyon";
			global.orderWindowHelpers.showNewWindow(url, 280, 350);
		}

		function setStatusOpen() {
			setBranchStatus(BRANCH_CONSTANTS.STATUS.OPEN);
		}

		function setStatusClosed() {
			setBranchStatus(BRANCH_CONSTANTS.STATUS.CLOSED);
		}

		function setStatusBusy() {
			setBranchStatus(BRANCH_CONSTANTS.STATUS.BUSY);
		}

		function showNotificationSettings(ev) {
			$mdDialog.show({
				controller: "NotificationSettingsDialogController",
				controllerAs: "vm",
				templateUrl: "app/main/dialogs/notificationSettings/notificationSettings-dialog.html",
				parent: angular.element(document.body),
				targetEvent: ev,
				scope: $rootScope,
				preserveScope: true,
				clickOutsideToClose: true,
				locals: {
					branchId: vm.branchId,
					smallBranchObj: vm.smallBranchObj
				}
			});
		}

		function approveOrder(order) {
			$mdDialog.show({
				controller: "ApproveOrderDialogController",
				controllerAs: "vm",
				templateUrl: "app/main/branchOrderDetails/dialogs/approve-order-dialog/approve-order-dialog.html",
				parent: angular.element(document.body),
				scope: $rootScope,
				preserveScope: true,
				clickOutsideToClose: false,
				locals: {
					approveOrderCallbackFunction: approveOrderCallbackFunction,
					order: order
				}
			});
		}

		function approveOrderCallbackFunction(order, estimatedPreparingOrDeliveryTimeInMinutes) {
			approveOrderWithMins(order, estimatedPreparingOrDeliveryTimeInMinutes)
		}

		function approveOrderWithMins(order, estimatedPreparingOrDeliveryTimeInMinutes) {
			vm.progressbar.start();
			$rootScope.global.showLoadingModal();
			vm.isApproveOrRefuseProcessing = true;
			api
				.approveOrder({
					orderId: order.orderKey,
					estimatedPreparingOrDeliveryTimeInMinutes: parseInt(estimatedPreparingOrDeliveryTimeInMinutes)
				})
				.then(function(result) {
					$timeout(function() {
						vm.isApproveOrRefuseProcessing = false;
						vm.progressbar.complete();
						$rootScope.global.hideLoadingModal();
						showToast("Sipariş Onaylandı");
						order.currentStatus = ORDER_STATUSES.PREP.code;
						order.currentStatusText = ORDER_STATUSES.PREP.text;
						processListsCurrentOrders();
					});
				})
				.catch(function(errorData) {
					$timeout(function() {
						vm.isApproveOrRefuseProcessing = false;
						console.log(errorData);
            if (
              errorData &&
              errorData.data &&
              errorData.data.error &&
              errorData.data.error.type &&
              errorData.data.error.type == "knownErrors"
            ) {
              alert(errorData.data.error.message);
            } else {
              alert("Bir hata oluştu lütfen tekrar deneyin");
            }
						vm.progressbar.complete();
						$rootScope.global.hideLoadingModal();
					});
				});
		}

		function refuseOrder(order, ev) {
			$mdDialog.show({
				controller: "RejectOrderDialogController",
				controllerAs: "vm",
				templateUrl: "app/main/branchOrderDetails/dialogs/reject-order/reject-order-dialog.html",
				parent: angular.element(document.body),
				targetEvent: ev,
				scope: $rootScope,
				preserveScope: true,
				clickOutsideToClose: false,
				locals: {
					orderId: order.orderKey,
					order: order,
					isApproveOrRefuseProcessing: vm.isApproveOrRefuseProcessing,
					afterRefuse: afterRefuse
				}
			});
		}

		function afterRefuse() {
			$timeout(function() {
				showToast("Sipariş Reddedildi. RESTORAN YOĞUN olarak durumunuzu değiştirmenizi öneririz.");
			}, 5000);
			processOrders();
		}

		function showToast(msg) {
			$mdToast.show(
				$mdToast
				.simple()
				.textContent(msg)
				.position("top right")
				.hideDelay(3000)
			);
		}

		function createTestOrder() {
			vm.progressbar.start();
			$rootScope.global.showLoadingModal();
			apiAdmin
				.createTestOrder({
					branchId: vm.branchId
				})
				.then(function(result) {
					$timeout(function() {
						showToast("Deneme siparişi oluşturuldu");
						vm.progressbar.complete();
						$rootScope.global.hideLoadingModal();
					});
				})
				.catch(function(error) {
					showToast("Bir hata oluştu");
					if (
						error &&
						error.data &&
						error.data.error &&
						error.data.error.message
					) {
						alert(error.data.error.message);
					}
					vm.progressbar.complete();
					$rootScope.global.hideLoadingModal();
				});
		}

		function setStatusDone(order) {
			if (order.currentStatus !== ORDER_STATUSES.ONWAY.code) {
				alert(
					"Sipariş durumunu 'Tamamlandı' yapmak için şuandaki durumun 'Yolda' olması lazım."
				);
			} else {
				vm.progressbar.start();
				$rootScope.global.showLoadingModal();
				apiAdmin
					.setStatusDone({
						orderId: order.orderKey
					})
					.then(function(result) {
						$timeout(function() {
							showToast(ORDER_STATUSES.DONE.text);
							vm.progressbar.complete();
							$rootScope.global.hideLoadingModal();
							order.currentStatus = ORDER_STATUSES.DONE.code;
							order.currentStatusText = ORDER_STATUSES.DONE.text;
							processOrders();
						});
					})
					.catch(function(error) {
						console.log("error");
						console.log(error);
						showToast("Bir hata oluştu");
						if (
							error &&
							error.data &&
							error.data.error &&
							error.data.error.message
						) {
							alert(error.data.error.message);
						}
						vm.progressbar.complete();
						$rootScope.global.hideLoadingModal();
					});
			}
		}

		function setStatusOnWay(order) {
			if (order.currentStatus !== ORDER_STATUSES.PREP.code) {
				alert(
					"Sipariş durumunu 'Yolda' yapmak için şuandaki durumun 'Hazırlanıyor' olması lazım."
				);
			} else {
				vm.progressbar.start();
				$rootScope.global.showLoadingModal();
				apiAdmin
					.setStatusOnWay({
						orderId: order.orderKey
					})
					.then(function(result) {
						$timeout(function() {
							vm.progressbar.complete();
							$rootScope.global.hideLoadingModal();
							showToast(ORDER_STATUSES.ONWAY.text);
							order.currentStatus = ORDER_STATUSES.ONWAY.code;
							order.currentStatusText = ORDER_STATUSES.ONWAY.text;
							processListsCurrentOrders();
						});
					})
					.catch(function(error) {
						console.log("error");
						console.log(error);
						showToast("Bir hata oluştu");
						if (
							error &&
							error.data &&
							error.data.error &&
							error.data.error.message
						) {
							alert(error.data.error.message);
						}
						vm.progressbar.complete();
						$rootScope.global.hideLoadingModal();
					});
			}
		}

		function setBranchStatus(status) {
			vm.progressbar.start();
			$rootScope.global.showLoadingModal();
			dataLib
				.getBranchPublicBranchStatusRefById(vm.branchId)
				.set(status)
				.then(function() {
					showToast("Kaydedildi");
					vm.progressbar.complete();
					$rootScope.global.hideLoadingModal();
					vm.branchStatus = status;
				});
		}

		function setMasterStatusClose() {
			dataLib
				.getBranchMasterStatusRefById(vm.branchId)
				.set(BRANCH_CONSTANTS.MASTER_STATUS.CLOSED)
				.then(function() {
					getBranchStatus();
				});
		}

		function setMasterStatusOpen() {
			dataLib
				.getBranchMasterStatusRefById(vm.branchId)
				.set(BRANCH_CONSTANTS.MASTER_STATUS.OPEN)
				.then(function() {
					getBranchStatus();
				});
		}

		function getBranchStatus() {
			return dataLib
				.getBranchPublicBranchStatusRefById(vm.branchId)
				.once("value")
				.then(function(branchStatusSnap) {
					$timeout(function() {
						vm.branchStatus = branchStatusSnap.val();
					});
					return dataLib
						.getBranchMasterStatusRefById(vm.branchId)
						.once("value");
				})
				.then(function(masterStatusSnap) {
					$timeout(function() {
						vm.masterStatus = masterStatusSnap.val();
						return Q.resolve({});
					});
				});
		}

		function getBranchData() {
			vm.progressbar.start();
			$rootScope.global.showLoadingModal();
			dataLib
				.getBranchPublicNameObjById(vm.branchId)
				.then(function(smallBranchObj) {
					$timeout(function() {
						vm.smallBranchObj = smallBranchObj;
					});
					return getBranchStatus();
				})
				.then(function(result) {
					vm.isLoading = false;
					vm.progressbar.complete();
					$rootScope.global.hideLoadingModal();
					return Q.resolve({});
				});
		}

		function init() {
			getBranchData();
		}

		dataLib
			.getBranchListsRefById($stateParams.branchId)
			.on("value", function(snap) {
				processOrders();
			});

		function processListsOrders() {
			dataLib
				.getBranchOrdersRefById($stateParams.branchId)
				.once("value", function(snap) {
					var orders = snap.val();
					dataLib.getOrdersByOrderKeys(orders).then(function(result) {
						$timeout(function() {
							vm.orders = result;
						});
					});
				});
		}

		function processListsCurrentOrders() {
			dataLib
				.getBranchCurrentOrdersRefById($stateParams.branchId)
				.once("value", function(snap) {
					var currentOrders = snap.val();
					dataLib.getOrdersByOrderKeys(currentOrders).then(function(result) {
						$timeout(function() {
							vm.currentOrders = result;
						});
					});
				});
		}

		function processListsFinishedOrders() {
			dataLib
				.getBranchFinishedOrdersRefById($stateParams.branchId)
				.limitToLast(20)
				.once("value", function(snap) {
					var finishedOrders = snap.val();
					dataLib.getOrdersByOrderKeys(finishedOrders).then(function(result) {
						$timeout(function() {
							vm.finishedOrders = result;
						});
					});
				});
		}

		function processOrders() {
			processListsOrders();
			processListsCurrentOrders();
			processListsFinishedOrders();
			$timeout(function () {
				processListsCurrentOrders();
			}, 1000);
		}

		$scope.$on("$destroy", function() {
			vm.orders = {};
			vm.currentOrders = {};
			vm.finishedOrders = {};
			dataLib.getBranchListsRefById($stateParams.branchId).off();
		});

		init();
	}
})();

(function() {
	"use strict";

	angular.module("app.branch").controller("BranchController", BranchController);
	/** @ngInject */
	function BranchController(
		$scope,
		$rootScope
	) {
		$scope.$on("$viewContentAnimationEnded", function(event) {
			if (event.targetScope.$id === $scope.$id) {
				$rootScope.$broadcast("msSplashScreen::remove");
			}
		});
	}
})();


(function() {
	"use strict";

	angular
		.module("app.branch")
		.controller("BranchOrderDetailsController", BranchOrderDetailsController);

	/** @ngInject */
	function BranchOrderDetailsController(
		api,
		apiStream,
		$stateParams,
		$state,
		ngProgressFactory,
		$timeout,
		$mdDialog,
		$rootScope,
		$q,
    $mdToast,
    apiAdmin
	) {
		var vm = this;

		vm.smallBranchObj;
		vm.isLoading = true;
		vm.isApproveOrRefuseProcessing = false;
		vm.order = {};
		vm.orderId = $stateParams.orderId;
		vm.appId;
		vm.appHostname = "";
		vm.branchId = $stateParams.branchId;
		vm.progressbar = ngProgressFactory.createInstance();

		vm.getSubTotal = getSubTotal;
		vm.isSubTotalVisible = isSubTotalVisible;
		vm.approveOrder = approveOrder;
		vm.refuseOrder = refuseOrder;
		vm.print = print;

		vm.inviteFormModel = {};
		vm.hasValidOwner = true;
		vm.isValidOwnerLoading = false;
		vm.isDailyTestOrderEnabled = false;

		function getSubTotal() {
			var subTotal = vm.order.total;
			if (vm.order.isUserUsedCredit) {
				subTotal = subTotal + vm.order.usedCreditsBalance;
			}
			if (vm.order.giveDiscountFirstNthOrdersDetails) {
				subTotal = subTotal + vm.order.campaigns.giveDiscountFirstNthOrders.discount;
			}
			if (vm.order.percentageDiscountForBucket) {
				subTotal = subTotal + parseFloat(vm.order.campaigns.percentageDiscountForBucket.calculatedPercentDiscount);
			}
			if (vm.order.isInvitationDiscountAvailable) {
				subTotal = subTotal + vm.order.campaigns.inviteFriends.invitedDiscount;
			}
			if (vm.order.isJokerAvailable) {
				subTotal = subTotal + vm.order.campaigns.joker.discount;
			}
			return subTotal;
		}

		function isSubTotalVisible() {
			return (
				vm.order.isUserUsedCredit ||
				vm.order.giveDiscountFirstNthOrdersDetails ||
				vm.order.percentageDiscountForBucket ||
				vm.order.isJokerAvailable ||
				vm.order.isInvitationDiscountAvailable
			);
		}

		function showToast(msg) {
			$mdToast.show(
				$mdToast
				.simple()
				.textContent(msg)
				.position("top right")
				.hideDelay(3000)
			);
		}

		function approveOrder() {
			$mdDialog.show({
				controller: "ApproveOrderDialogController",
				controllerAs: "vm",
				templateUrl: "app/main/branchOrderDetails/dialogs/approve-order-dialog/approve-order-dialog.html",
				parent: angular.element(document.body),
				scope: $rootScope,
				preserveScope: true,
				clickOutsideToClose: false,
				locals: {
					approveOrderCallbackFunction: approveOrderCallbackFunction,
					order: null
				}
			});
		}

		function approveOrderCallbackFunction(order, estimatedPreparingOrDeliveryTimeInMinutes) {
			approveOrderWithMins(estimatedPreparingOrDeliveryTimeInMinutes)
		}

		function approveOrderWithMins(estimatedPreparingOrDeliveryTimeInMinutes) {
			vm.progressbar.start();
			$rootScope.global.showLoadingModal();
			vm.isApproveOrRefuseProcessing = true;
			api
				.approveOrder({
					orderId: $stateParams.orderId,
					estimatedPreparingOrDeliveryTimeInMinutes: parseInt(estimatedPreparingOrDeliveryTimeInMinutes)
				})
				.then(function(result) {
					console.log(result);
					$timeout(function() {
						vm.order.currentStatus = ORDER_STATUSES.PREP.code;
						vm.isApproveOrRefuseProcessing = false;
						vm.progressbar.complete();
						$rootScope.global.hideLoadingModal();
						showToast("Sipariş Onaylandı");
					});
				})
				.catch(function(err) {
					console.log(err);
					if (
						err &&
						err.data &&
						err.data.error &&
						err.data.error.type &&
						err.data.error.type == "knownErrors"
					) {
						global.util.showNotification('Otomatik Yazdırma', err.data.error.message);
					} else {
						global.util.showNotification('Otomatik Yazdırma', "Bilinmeyen hata! daha sonra Tekrar deneyiniz.");
					}

					$timeout(function() {
						vm.isApproveOrRefuseProcessing = false;
						vm.progressbar.complete();
						$rootScope.global.hideLoadingModal();
					});
				});
		}

		function refuseOrder(ev) {
			$mdDialog.show({
				controller: "RejectOrderDialogController",
				controllerAs: "vm",
				templateUrl: "app/main/branchOrderDetails/dialogs/reject-order/reject-order-dialog.html",
				parent: angular.element(document.body),
				targetEvent: ev,
				scope: $rootScope,
				preserveScope: true,
				clickOutsideToClose: false,
				locals: {
					orderId: $stateParams.orderId,
					order: vm.order,
					isApproveOrRefuseProcessing: vm.isApproveOrRefuseProcessing,
					afterRefuse: afterRefuse
				}
			});
		}

		function afterRefuse() {
			$timeout(function() {
				showToast("Sipariş Reddedildi. RESTORAN YOĞUN olarak durumunuzu değiştirmenizi öneririz.");
			}, 5000);
		}

		function init() {
			$timeout(function() {
				vm.isLoading = true;
			});
			vm.progressbar.start();
			$rootScope.global.showLoadingModal();
			dataLib
				.getBranchPublicNameObjById(vm.branchId)
				.then(function(smallBranchObj) {
					$timeout(function() {
						vm.smallBranchObj = smallBranchObj;
					});
					return dataLib.getOrderByIdRef(vm.orderId).once("value");
				})
				.then(function(snap) {
					var orderData = snap.val();
					$timeout(function() {
						vm.isLoading = false;
						vm.order = orderData;
						console.log("vm.order");
						console.log(vm.order);
						if (!vm.order.read) {
							dataLib
								.getOrderByIdRef(vm.orderId)
								.child("read")
								.set(true);
						}
						vm.appId = vm.order.appId;
						checkIsInDevelopmentMode();
						if (!vm.order) {
							$state.go("app.branch.orders");
						}
						vm.progressbar.complete();
						$rootScope.global.hideLoadingModal();
					});
					return dataLib
						.getAppPublicHostnameByIdRef(orderData.appId)
						.once("value");
				})
				.then(function(hostnameSnap) {
					console.log("hostnameSnap");
					console.log(hostnameSnap);
					$timeout(function() {
						vm.appHostname = hostnameSnap.val();
					});
				})
				.catch(function(err) {
					console.log(err);
					$state.go("app.branch.orders");
				});
		}

		vm.isInDevelopmentMode = false;

		function checkIsInDevelopmentMode() {
			if (vm.order.isTestOrder) {
				dataLib
					.getAppPublicIsInDevelopmentModeRef(vm.appId)
					.once("value")
					.then(function(snap) {
						$timeout(function() {
							vm.isInDevelopmentMode = snap.val();
						});
					});
			}
		}

		init();

		function formatDate(date) {
			return moment(date).format("DD/MM/YY HH:mm");
    }

    vm.yourIpAddress = "";
    vm.getOrderStatusIpAddress = function () {
      vm.isGetOrderStatusIpAddressBtnHidden = true;
      apiAdmin
        .getOrderStatusIpAddresses({
          orderId: vm.orderId
        }).then(function (result) {
          if(result.data){
            vm.yourIpAddress = result.data.yourIpAddress;
            $timeout(function(){
              if(result.data.keys){
                for(var key in result.data.keys){
                  vm.order.statusLogs[key].ipAddress = result.data.keys[key]
                }
              }
            });
          }
        });
    }

		function print(paperType, font) {
			global.orderWindowHelpers.printOrder($stateParams.branchId, $stateParams.orderId, paperType, font);
			global.util.showNotification('Otomatik Yazdırma', 'Yazdırmaya başlıyor.');
		}
	}
})();

var chromeIosWarning = "Yazdırma seçeneklerini görmek için => '3 noktalı menü > Paylaş > Yazdır'.";

chromeIosWarning += " Lütfen yazdırmak için safari'yi kullanın.";

function printPrintFrame() {
	var mywindow = window.frames["printf"];
	mywindow.focus();
	mywindow.print();
	if (isChromeIOS()) {
		alert(chromeIosWarning);
	}
}

function removePrintFrame() {
	$("iframe#printf").remove();
}

var global;
(function() {
	"use strict";

	angular
		.module("app.branch")
		.controller("BranchListController", BranchListController);

	/** @ngInject */
	function BranchListController(
		$timeout,
		$state,
		$mdDialog,
		$rootScope
	) {
		var vm = this;
		vm.branchs;
		vm.branchLen = 0;
		vm.URLify = URLify;
		vm.isLoading = true;
		vm.openBranchAutoPrintSettingsDialog = openBranchAutoPrintSettingsDialog;
		vm.openBranchOrdersWindow = openBranchOrdersWindow;
		vm.branchSettingsBranchsObj;

		salesRepresentativeHelpers.checkSalesRepresentativeStatus()
			.then(function () {
				dataLib.getBranchsOfUser().then(function(branchs) {
					$timeout(function() {
						vm.isLoading = false;
						vm.branchs = branchs;
						var branchKeysArray = Object.keys(vm.branchs);
						vm.branchLen = branchKeysArray.length;
					}, 500);
				});
			});

		if (global) {
			var currentUser = global.firebaseUser;
			if (global.autoprintSettings && global.autoprintSettings.users && global.autoprintSettings.users[currentUser.uid]) {
				vm.branchSettingsBranchsObj = global.autoprintSettings.users[currentUser.uid].branchs
			}
		}

    // global.orderWindowHelpers.openOrderDetailWindow('-L9G-Fml1Co5jBumm2ez', '-L9bE0tEbSniBN9CEPrq');

		function openBranchOrdersWindow(branch, branchKey) {
			var params = {
				appName: vm.URLify(branch.appName.toString()),
				name: vm.URLify(branch.name.toString()),
				branchId: branchKey
			};
			var url = global.webOrigin + $state.href('app.branch.orders', params);
			global.orderWindowHelpers.showNewWindow(url);
		}

		function openBranchAutoPrintSettingsDialog(branch, ev) {
			$mdDialog.show({
				controller: "BranchAutoPrintSettingsDialogController",
				controllerAs: "vm",
				templateUrl: "app/main/branchList/branchAutoPrintSettings/branchAutoPrintSettings-dialog.html",
				parent: angular.element(document.body),
				targetEvent: ev,
				scope: $rootScope,
				preserveScope: true,
				escapeToClose: true,
				clickOutsideToClose: true,
				locals: {
					branch: branch
				}
			});
		}
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('angularhadiyemekTheming', angularhadiyemekThemingService);

    /** @ngInject */
    function angularhadiyemekThemingService($log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, angularhadiyemekPalettes, angularhadiyemekThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
          angularhadiyemekThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(angularhadiyemekPalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(angularhadiyemekThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();

(function() {
	'use strict';

	var angularhadiyemekThemes = {
		default: {
			primary: {
				name: 'angularhadiyemek-pplue',
				hues: {
					'default': '700',
					'hue-1': '500',
					'hue-2': '600',
					'hue-3': '400'
				}
			},
			accent: {
				name: 'light-blue',
				hues: {
					'default': '600',
					'hue-1': '400',
					'hue-2': '700',
					'hue-3': 'A100'
				}
			},
			warn: {
				name: 'red'
			},
			background: {
				name: 'grey',
				hues: {
					'default': 'A100',
					'hue-1': 'A100',
					'hue-2': '100',
					'hue-3': '300'
				}
			}
		},
		'pinkTheme': {
			primary: {
				name: 'blue-grey',
				hues: {
					'default': '800',
					'hue-1': '600',
					'hue-2': '400',
					'hue-3': 'A100'
				}
			},
			accent: {
				name: 'pink',
				hues: {
					'default': '400',
					'hue-1': '300',
					'hue-2': '600',
					'hue-3': 'A100'
				}
			},
			warn: {
				name: 'blue'
			},
			background: {
				name: 'grey',
				hues: {
					'default': 'A100',
					'hue-1': 'A100',
					'hue-2': '100',
					'hue-3': '300'
				}
			}
		},
		'tealTheme': {
			primary: {
				name: 'angularhadiyemek-blue',
				hues: {
					'default': '900',
					'hue-1': '600',
					'hue-2': '500',
					'hue-3': 'A100'
				}
			},
			accent: {
				name: 'teal',
				hues: {
					'default': '500',
					'hue-1': '400',
					'hue-2': '600',
					'hue-3': 'A100'
				}
			},
			warn: {
				name: 'deep-orange'
			},
			background: {
				name: 'grey',
				hues: {
					'default': 'A100',
					'hue-1': 'A100',
					'hue-2': '100',
					'hue-3': '300'
				}
			}
		}
	};

	angular
		.module('app.core')
		.constant('angularhadiyemekThemes', angularhadiyemekThemes);
})();

(function () {
    'use strict';

    var angularhadiyemekPalettes = [
        {
            name: 'angularhadiyemek-blue',
            options: {
                '50': '#ebf0fa',
                '100': '#c2d3ef',
                '200': '#9ab9e5',
                '300': '#78a0dc',
                '400': '#5788d3',
                '500': '#3460ca',
                '600': '#2e63b1',
                '700': '#275499',
                '800': '#21467f',
                '900': '#1a3864',
                'A100': '#c2d4ee',
                'A200': '#9ab8e6',
                'A400': '#5688d4',
                'A700': '#276498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'angularhadiyemek-pplue',
            options: {
                '50': '#ececef',
                '100': '#c5d6cb',
                '200': '#9ea2a9',
                '300': '#7d818c',
                '400': '#5d616f',
                '500': '#3c4252',
                '600': '#353b48',
                '700': '#2d333e',
                '800': '#262943',
                '900': '#1e2128',
                'A100': '#c5c6bb',
                'A200': '#9eb1a9',
                'A400': '#5c516f',
                'A700': '#2d313e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('angularhadiyemekPalettes', angularhadiyemekPalettes);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('angularhadiyemekGenerator', angularhadiyemekGeneratorService);

    /** @ngInject */
    function angularhadiyemekGeneratorService($log, angularhadiyemekTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(angularhadiyemekTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(angularhadiyemekTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            angularhadiyemekTheming.setThemesList(themes);

            angularhadiyemekTheming.setActiveTheme('default');
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, angularhadiyemekTheming)
    {
        var vm = this;

        // Data
        vm.themes = angularhadiyemekTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
          angularhadiyemekTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return angularhadiyemekTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        //
                        $mdSidenav('angularhadiyemek-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function() {
  "use strict";

  angular.module("app.core").filter("altDate", altDate);

  /** @ngInject */
  function altDate() {
    return function(value) {
      var diff = Date.now() - new Date(value);

      /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
      if (diff < 60 * 60 * 1000) {
        return moment(value).fromNow();
      } else if (diff < 60 * 60 * 24 * 1000) {
        /*
             * If in the day
             * e.g. "11:23"
             */
        return moment(value).format("HH:mm");
      } else if (diff < 60 * 60 * 24 * 7 * 1000) {
        /*
             * If in week
             * e.g "Tuesday"
             */
        return moment(value).format("dddd");
      } else {
        /*
             * If more than a week
             * e.g. 03/29/2016
             */
        return moment(value).calendar();
      }
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('angularhadiyemekConfig', angularhadiyemekConfigProvider);

    /** @ngInject */
    function angularhadiyemekConfigProvider()
    {
        // Default configuration
        var angularhadiyemekConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
          angularhadiyemekConfiguration = angular.extend({}, angularhadiyemekConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(angularhadiyemekConfiguration[configName]) )
                {
                    return false;
                }

                return angularhadiyemekConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
              angularhadiyemekConfiguration[configName] = configValue;
            }
        };
    }

})();

(function() {
	'use strict';

	angular
		.module('app.toolbar', [])
		.config(config);

	/** @ngInject */
	function config() {

	}
})();

(function() {
	'use strict';

	angular
		.module('app.toolbar')
		.controller('ToolbarController', ToolbarController);

	/** @ngInject */
	function ToolbarController($rootScope, $q, $mdDialog, $state, $timeout, $mdSidenav, $mdToast, msNavigationService) {
		var vm = this;

		// Data
		$rootScope.global.search = '';

		vm.bodyEl = angular.element('body');

		// Methods
		vm.toggleSidenav = toggleSidenav;
		vm.logout = logout;
		vm.setUserStatus = setUserStatus;
		vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
		vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
		vm.search = search;
		vm.searchResultClick = searchResultClick;
		vm.passwordUpdate = passwordUpdate;
    vm.showNotificationMobileSettings = showNotificationMobileSettings;
		//////////

		init();

		/**
		 * Initialize
		 */
		function init() {
    }



    function showNotificationMobileSettings(ev) {
      $mdDialog.show({
        controller: "NotificationMobileSettingsDialogController",
        controllerAs: "vm",
        templateUrl:
          "app/main/dialogs/notificationMobileSettings/notificationMobileSettings-dialog.html",
        parent: angular.element(document.body),
        targetEvent: ev,
        scope: $rootScope,
        preserveScope: true,
        clickOutsideToClose: true,
        locals: {}
      });
    }

    function passwordUpdate(ev) {
        $mdDialog.show({
          controller: 'PasswordUpdateDialogController',
          controllerAs: 'vm',
          templateUrl: 'app/main/dialogs/passwordUpdate/passwordUpdate-dialog.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          scope: $rootScope,
          preserveScope: true,
          clickOutsideToClose: true,
          locals: {}
        });
    }

		/**
		 * Toggle sidenav
		 *
		 * @param sidenavId
		 */
		function toggleSidenav(sidenavId) {
			$mdSidenav(sidenavId).toggle();
		}

		/**
		 * Sets User Status
		 * @param status
		 */
		function setUserStatus(status) {
			vm.userStatus = status;
		}

		/**
		 * Logout Function
		 */
		function logout() {
			$state.go("app.login");
			firebaseHelper.signOut();
		}

		/**
		 * Toggle horizontal mobile menu
		 */
		function toggleHorizontalMobileMenu() {
			vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
		}

		/**
		 * Toggle msNavigation folded
		 */
		function toggleMsNavigationFolded() {
			msNavigationService.toggleFolded();
		}

		/**
		 * Search action
		 *
		 * @param query
		 * @returns {Promise}
		 */
		function search(query) {
			var navigation = [],
				flatNavigation = msNavigationService.getFlatNavigation(),
				deferred = $q.defer();

			// Iterate through the navigation array and
			// make sure it doesn't have any groups or
			// none ui-sref items
			for (var x = 0; x < flatNavigation.length; x++) {
				if (flatNavigation[x].uisref) {
					navigation.push(flatNavigation[x]);
				}
			}

			// If there is a query, filter the navigation;
			// otherwise we will return the entire navigation
			// list. Not exactly a good thing to do but it's
			// for demo purposes.
			if (query) {
				navigation = navigation.filter(function(item) {
					if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
						return true;
					}
				});
			}

			// Fake service delay
			$timeout(function() {
				deferred.resolve(navigation);
			}, 1000);

			return deferred.promise;
		}

		/**
		 * Search result click action
		 *
		 * @param item
		 */
		function searchResultClick(item) {
			// If item has a link
			if (item.uisref) {
				// If there are state params,
				// use them...
				if (item.stateParams) {
					$state.go(item.state, item.stateParams);
				} else {
					$state.go(item.state);
				}
			}
		}
	}

})();

(function ()
{
    'use strict';
    /**

     */
    angular
        .module('angularhadiyemek', [
            'ngProgress',
            'app.core',
            'app.login',
            'app.branch',
            'app.toolbar',
        ]);
})();

(function() {
  "use strict";

  angular.module("angularhadiyemek").controller("MainController", MainController);

  /** @ngInject */
  function MainController($scope, $rootScope, $mdDialog) {
    // Data

    // Remove the splash screen
    $scope.$on("$viewContentAnimationEnded", function(event) {
      if (event.targetScope.$id === $scope.$id) {
        $rootScope.$broadcast("msSplashScreen::remove");
      }
    });

    firebase.auth().onAuthStateChanged(function(user) {
      firebaseHelper.processUser();
      $rootScope.$apply(function() {
        $rootScope.firebaseUser = firebaseApp.auth().currentUser;
        $rootScope.firebaseUserLinkedProviders = globalFirebaseUserLinkedProviders;
      });
      $rootScope.$emit("AUTH_STATE_CHANGED", {});
    });
  }
})();

'use strict';

function isIOS() {
	return window.navigator.userAgent.match(/(iPhone|iPod|iPad)/g) ? true : false;
}

function isChromeIOS() {
	return window.navigator.userAgent.match(/(CriOS)/g) ? true : false;
}



function formatTurkishLiraText(priceText) {
	return parseFloat(priceText).toFixed(2).toString().replace(',', '.');
}

function isValidMobileNumber(mobilePhone) {
	if (mobilePhone.toString() === "" || mobilePhone.toString().length !== 10 || mobilePhone.toString()[0] !== "5") {
		return false;
	}
	return true;
}

function isValidPhoneNumber(mobilePhone) {
	if (mobilePhone.toString() === "" || mobilePhone.toString().length !== 10) {
		return false;
	}
	return true;
}


var util = {
	getAppId: function() {
		// var params = util.getParamsObj();
		// return params.appId.split('.').join('>>');
		return window.location.hostname.replace('.dev.test', '').split('.').join('>>');
	},
	setMeta: function(name, content) {
		window.top.document.getElementsByName(name)[0].content = content;
	},
	getParamsObj: function() {
		var queryDict = {};
		location.search.substr(1).split("&").forEach(function(item) {
			queryDict[item.split("=")[0]] = item.split("=")[1]
		})
		delete queryDict[""];
		return queryDict;
	},
	makeFirstLetterUpperCase: function(input) {
		return (!!input) ? input.split(' ').map(function(wrd) {
			return wrd.charAt(0).toUpperCase() + wrd.substr(1).toLowerCase();
		}).join(' ') : '';
	}
};

var cardMonths = [{
		text: "Ocak",
		value: 1
	},
	{
		text: "Şubat",
		value: 2
	},
	{
		text: "Mart",
		value: 3
	},
	{
		text: "Nisan",
		value: 4
	},
	{
		text: "Mayıs",
		value: 5
	},
	{
		text: "Hazira",
		value: 6
	},
	{
		text: "Temmuz",
		value: 7
	},
	{
		text: "Ağusto",
		value: 8
	},
	{
		text: "Eylül",
		value: 9
	},
	{
		text: "Ekim",
		value: 10
	},
	{
		text: "Kasım",
		value: 11
	},
	{
		text: "Aralık",
		value: 12
	}
];

var cardDate = new Date();
var todayYear = cardDate.getFullYear();

var cardYears = [
	todayYear - 1,
	todayYear,
	todayYear + 1,
	todayYear + 2,
	todayYear + 3,
	todayYear + 4,
	todayYear + 5,
	todayYear + 6,
	todayYear + 7,
	todayYear + 8,
	todayYear + 9,
];


/**
 * GLOBAL slugify
 */
/*global XRegExp*/
(function() {
	'use strict';

	var LATIN_MAP = {
		'À': 'A',
		'Á': 'A',
		'Â': 'A',
		'Ã': 'A',
		'Ä': 'A',
		'Å': 'A',
		'Æ': 'AE',
		'Ç': 'C',
		'È': 'E',
		'É': 'E',
		'Ê': 'E',
		'Ë': 'E',
		'Ì': 'I',
		'Í': 'I',
		'Î': 'I',
		'Ï': 'I',
		'Ð': 'D',
		'Ñ': 'N',
		'Ò': 'O',
		'Ó': 'O',
		'Ô': 'O',
		'Õ': 'O',
		'Ö': 'O',
		'Ő': 'O',
		'Ø': 'O',
		'Ù': 'U',
		'Ú': 'U',
		'Û': 'U',
		'Ü': 'U',
		'Ű': 'U',
		'Ý': 'Y',
		'Þ': 'TH',
		'Ÿ': 'Y',
		'ß': 'ss',
		'à': 'a',
		'á': 'a',
		'â': 'a',
		'ã': 'a',
		'ä': 'a',
		'å': 'a',
		'æ': 'ae',
		'ç': 'c',
		'è': 'e',
		'é': 'e',
		'ê': 'e',
		'ë': 'e',
		'ì': 'i',
		'í': 'i',
		'î': 'i',
		'ï': 'i',
		'ð': 'd',
		'ñ': 'n',
		'ò': 'o',
		'ó': 'o',
		'ô': 'o',
		'õ': 'o',
		'ö': 'o',
		'ő': 'o',
		'ø': 'o',
		'ù': 'u',
		'ú': 'u',
		'û': 'u',
		'ü': 'u',
		'ű': 'u',
		'ý': 'y',
		'þ': 'th',
		'ÿ': 'y'
	};
	var LATIN_SYMBOLS_MAP = {
		'©': '(c)'
	};
	var GREEK_MAP = {
		'α': 'a',
		'β': 'b',
		'γ': 'g',
		'δ': 'd',
		'ε': 'e',
		'ζ': 'z',
		'η': 'h',
		'θ': '8',
		'ι': 'i',
		'κ': 'k',
		'λ': 'l',
		'μ': 'm',
		'ν': 'n',
		'ξ': '3',
		'ο': 'o',
		'π': 'p',
		'ρ': 'r',
		'σ': 's',
		'τ': 't',
		'υ': 'y',
		'φ': 'f',
		'χ': 'x',
		'ψ': 'ps',
		'ω': 'w',
		'ά': 'a',
		'έ': 'e',
		'ί': 'i',
		'ό': 'o',
		'ύ': 'y',
		'ή': 'h',
		'ώ': 'w',
		'ς': 's',
		'ϊ': 'i',
		'ΰ': 'y',
		'ϋ': 'y',
		'ΐ': 'i',
		'Α': 'A',
		'Β': 'B',
		'Γ': 'G',
		'Δ': 'D',
		'Ε': 'E',
		'Ζ': 'Z',
		'Η': 'H',
		'Θ': '8',
		'Ι': 'I',
		'Κ': 'K',
		'Λ': 'L',
		'Μ': 'M',
		'Ν': 'N',
		'Ξ': '3',
		'Ο': 'O',
		'Π': 'P',
		'Ρ': 'R',
		'Σ': 'S',
		'Τ': 'T',
		'Υ': 'Y',
		'Φ': 'F',
		'Χ': 'X',
		'Ψ': 'PS',
		'Ω': 'W',
		'Ά': 'A',
		'Έ': 'E',
		'Ί': 'I',
		'Ό': 'O',
		'Ύ': 'Y',
		'Ή': 'H',
		'Ώ': 'W',
		'Ϊ': 'I',
		'Ϋ': 'Y'
	};
	var TURKISH_MAP = {
		'ş': 's',
		'Ş': 'S',
		'ı': 'i',
		'İ': 'I',
		'ç': 'c',
		'Ç': 'C',
		'ü': 'u',
		'Ü': 'U',
		'ö': 'o',
		'Ö': 'O',
		'ğ': 'g',
		'Ğ': 'G'
	};
	var ROMANIAN_MAP = {
		'ă': 'a',
		'î': 'i',
		'ș': 's',
		'ț': 't',
		'â': 'a',
		'Ă': 'A',
		'Î': 'I',
		'Ș': 'S',
		'Ț': 'T',
		'Â': 'A'
	};
	var RUSSIAN_MAP = {
		'а': 'a',
		'б': 'b',
		'в': 'v',
		'г': 'g',
		'д': 'd',
		'е': 'e',
		'ё': 'yo',
		'ж': 'zh',
		'з': 'z',
		'и': 'i',
		'й': 'j',
		'к': 'k',
		'л': 'l',
		'м': 'm',
		'н': 'n',
		'о': 'o',
		'п': 'p',
		'р': 'r',
		'с': 's',
		'т': 't',
		'у': 'u',
		'ф': 'f',
		'х': 'h',
		'ц': 'c',
		'ч': 'ch',
		'ш': 'sh',
		'щ': 'sh',
		'ъ': '',
		'ы': 'y',
		'ь': '',
		'э': 'e',
		'ю': 'yu',
		'я': 'ya',
		'А': 'A',
		'Б': 'B',
		'В': 'V',
		'Г': 'G',
		'Д': 'D',
		'Е': 'E',
		'Ё': 'Yo',
		'Ж': 'Zh',
		'З': 'Z',
		'И': 'I',
		'Й': 'J',
		'К': 'K',
		'Л': 'L',
		'М': 'M',
		'Н': 'N',
		'О': 'O',
		'П': 'P',
		'Р': 'R',
		'С': 'S',
		'Т': 'T',
		'У': 'U',
		'Ф': 'F',
		'Х': 'H',
		'Ц': 'C',
		'Ч': 'Ch',
		'Ш': 'Sh',
		'Щ': 'Sh',
		'Ъ': '',
		'Ы': 'Y',
		'Ь': '',
		'Э': 'E',
		'Ю': 'Yu',
		'Я': 'Ya'
	};
	var UKRAINIAN_MAP = {
		'Є': 'Ye',
		'І': 'I',
		'Ї': 'Yi',
		'Ґ': 'G',
		'є': 'ye',
		'і': 'i',
		'ї': 'yi',
		'ґ': 'g'
	};
	var CZECH_MAP = {
		'č': 'c',
		'ď': 'd',
		'ě': 'e',
		'ň': 'n',
		'ř': 'r',
		'š': 's',
		'ť': 't',
		'ů': 'u',
		'ž': 'z',
		'Č': 'C',
		'Ď': 'D',
		'Ě': 'E',
		'Ň': 'N',
		'Ř': 'R',
		'Š': 'S',
		'Ť': 'T',
		'Ů': 'U',
		'Ž': 'Z'
	};
	var POLISH_MAP = {
		'ą': 'a',
		'ć': 'c',
		'ę': 'e',
		'ł': 'l',
		'ń': 'n',
		'ó': 'o',
		'ś': 's',
		'ź': 'z',
		'ż': 'z',
		'Ą': 'A',
		'Ć': 'C',
		'Ę': 'E',
		'Ł': 'L',
		'Ń': 'N',
		'Ó': 'O',
		'Ś': 'S',
		'Ź': 'Z',
		'Ż': 'Z'
	};
	var LATVIAN_MAP = {
		'ā': 'a',
		'č': 'c',
		'ē': 'e',
		'ģ': 'g',
		'ī': 'i',
		'ķ': 'k',
		'ļ': 'l',
		'ņ': 'n',
		'š': 's',
		'ū': 'u',
		'ž': 'z',
		'Ā': 'A',
		'Č': 'C',
		'Ē': 'E',
		'Ģ': 'G',
		'Ī': 'I',
		'Ķ': 'K',
		'Ļ': 'L',
		'Ņ': 'N',
		'Š': 'S',
		'Ū': 'U',
		'Ž': 'Z'
	};
	var ARABIC_MAP = {
		'أ': 'a',
		'ب': 'b',
		'ت': 't',
		'ث': 'th',
		'ج': 'g',
		'ح': 'h',
		'خ': 'kh',
		'د': 'd',
		'ذ': 'th',
		'ر': 'r',
		'ز': 'z',
		'س': 's',
		'ش': 'sh',
		'ص': 's',
		'ض': 'd',
		'ط': 't',
		'ظ': 'th',
		'ع': 'aa',
		'غ': 'gh',
		'ف': 'f',
		'ق': 'k',
		'ك': 'k',
		'ل': 'l',
		'م': 'm',
		'ن': 'n',
		'ه': 'h',
		'و': 'o',
		'ي': 'y'
	};
	var LITHUANIAN_MAP = {
		'ą': 'a',
		'č': 'c',
		'ę': 'e',
		'ė': 'e',
		'į': 'i',
		'š': 's',
		'ų': 'u',
		'ū': 'u',
		'ž': 'z',
		'Ą': 'A',
		'Č': 'C',
		'Ę': 'E',
		'Ė': 'E',
		'Į': 'I',
		'Š': 'S',
		'Ų': 'U',
		'Ū': 'U',
		'Ž': 'Z'
	};
	var SERBIAN_MAP = {
		'ђ': 'dj',
		'ј': 'j',
		'љ': 'lj',
		'њ': 'nj',
		'ћ': 'c',
		'џ': 'dz',
		'đ': 'dj',
		'Ђ': 'Dj',
		'Ј': 'j',
		'Љ': 'Lj',
		'Њ': 'Nj',
		'Ћ': 'C',
		'Џ': 'Dz',
		'Đ': 'Dj'
	};
	var AZERBAIJANI_MAP = {
		'ç': 'c',
		'ə': 'e',
		'ğ': 'g',
		'ı': 'i',
		'ö': 'o',
		'ş': 's',
		'ü': 'u',
		'Ç': 'C',
		'Ə': 'E',
		'Ğ': 'G',
		'İ': 'I',
		'Ö': 'O',
		'Ş': 'S',
		'Ü': 'U'
	};

	var ALL_DOWNCODE_MAPS = [
		LATIN_MAP,
		LATIN_SYMBOLS_MAP,
		GREEK_MAP,
		TURKISH_MAP,
		ROMANIAN_MAP,
		RUSSIAN_MAP,
		UKRAINIAN_MAP,
		CZECH_MAP,
		POLISH_MAP,
		LATVIAN_MAP,
		ARABIC_MAP,
		LITHUANIAN_MAP,
		SERBIAN_MAP,
		AZERBAIJANI_MAP
	];

	var Downcoder = {
		'Initialize': function() {
			if (Downcoder.map) { // already made
				return;
			}
			Downcoder.map = {};
			Downcoder.chars = [];
			for (var i = 0; i < ALL_DOWNCODE_MAPS.length; i++) {
				var lookup = ALL_DOWNCODE_MAPS[i];
				for (var c in lookup) {
					if (lookup.hasOwnProperty(c)) {
						Downcoder.map[c] = lookup[c];
					}
				}
			}
			for (var k in Downcoder.map) {
				if (Downcoder.map.hasOwnProperty(k)) {
					Downcoder.chars.push(k);
				}
			}
			Downcoder.regex = new RegExp(Downcoder.chars.join('|'), 'g');
		}
	};

	function downcode(slug) {
		Downcoder.Initialize();
		return slug.replace(Downcoder.regex, function(m) {
			return Downcoder.map[m];
		});
	}


	function URLify(s, num_chars, allowUnicode) {
		if (!s) {
			return "URLify-string-is-not-defined".toLowerCase();
		}
		// changes, e.g., "Petty theft" to "petty-theft"
		// remove all these words from the string before urlifying
		if (!allowUnicode) {
			s = downcode(s);
		}
		var removelist = [
			// "a", "an", "as", "at", "before", "but", "by", "for", "from", "is",
			// "in", "into", "like", "of", "off", "on", "onto", "per", "since",
			// "than", "the", "this", "that", "to", "up", "via", "with"
		];
		var r = new RegExp('\\b(' + removelist.join('|') + ')\\b', 'gi');
		s = s.replace(r, '');
		// if downcode doesn't hit, the char will be stripped here
		if (allowUnicode) {
			// Keep Unicode letters including both lowercase and uppercase
			// characters, whitespace, and dash; remove other characters.
			s = XRegExp.replace(s, XRegExp('[^-_\\p{L}\\p{N}\\s]', 'g'), '');
		} else {
			s = s.replace(/[^-\w\s]/g, ''); // remove unneeded chars
		}
		s = s.replace(/^\s+|\s+$/g, ''); // trim leading/trailing spaces
		s = s.replace(/[-\s]+/g, '-'); // convert spaces to hyphens
		s = s.toLowerCase(); // convert to lowercase
		return s.substring(0, num_chars); // trim to first num_chars chars
	}
	window.URLify = URLify;
})();

var isWindowVisible;
(function() {
	var hidden = "hidden";

	// Standards:
	if (hidden in document)
		document.addEventListener("visibilitychange", onchange);
	else if ((hidden = "mozHidden") in document)
		document.addEventListener("mozvisibilitychange", onchange);
	else if ((hidden = "webkitHidden") in document)
		document.addEventListener("webkitvisibilitychange", onchange);
	else if ((hidden = "msHidden") in document)
		document.addEventListener("msvisibilitychange", onchange);
	// IE 9 and lower:
	else if ("onfocusin" in document)
		document.onfocusin = document.onfocusout = onchange;
	// All others:
	else
		window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange;

	function onchange(evt) {
		var v = "visible",
			h = "hidden",
			evtMap = {
				focus: v,
				focusin: v,
				pageshow: v,
				blur: h,
				focusout: h,
				pagehide: h
			};

		evt = evt || window.event;
		if (evt.type in evtMap) {
			//   document.body.className = evtMap[evt.type];
			isWindowVisible = evtMap[evt.type];
		} else {
			//   document.body.className = this[hidden] ? "hidden" : "visible";
			isWindowVisible = this[hidden] ? "hidden" : "visible";
		}
	}
	// set the initial state (but only if browser supports the Page Visibility API)
	if (document[hidden] !== undefined)
		onchange({
			type: document[hidden] ? "blur" : "focus"
		});
})();
setInterval(function() {
	if (isWindowVisible === "hidden") {
		window.location.reload();
	}
}, (1000 * 60 * 60));

'use strict';
var isPrerenderSearchEngine = false;
if (window.top.location.href.indexOf("?_escaped_fragment_=") !== -1) {
	isPrerenderSearchEngine = true;
}
if (window.navigator.userAgent.indexOf("rerender") !== -1) {
	isPrerenderSearchEngine = true;
}

var globalFirebaseUserLinkedProviders;
var globalFirebaseUser;

var ssoOrigin = "https://sso.hadiyemek.com";
var firebaseApp;
var isFirebaseInitialized = false;

var isUserDeleteProcessing = false;

var firebaseConfig = {
	apiKey: "AIzaSyCDXOWPfklnyUamrDVR9icZWj6oY9kdRRE",
    authDomain: "hadiyemekcom.firebaseapp.com",
    databaseURL: "https://hadiyemekcom.firebaseio.com",
    projectId: "hadiyemekcom",
    storageBucket: "hadiyemekcom-euwest3-fra",
    messagingSenderId: "199695612527"
};

function updateMonitorRef() {
	setTimeout(function() {
		if (!IS_BOT_BROWSER && globalFirebaseUser) {
			if (Raven && typeof Raven.setUserContext === "function") {
				Raven.setUserContext({
					id: globalFirebaseUser.uid,
					email: globalFirebaseUser.email,
				});
			}
		}
	});
	setTimeout(function() {
		if (!IS_BOT_BROWSER && globalFirebaseUser && typeof FS !== 'undefined') {
			if (FS && typeof FS.identify === "function") {
				FS.identify(globalFirebaseUser.uid, {
					isAnonymous: globalFirebaseUser.isAnonymous,
					displayName: globalFirebaseUser.displayName,
					email: globalFirebaseUser.email,
					emailVerified: globalFirebaseUser.emailVerified,
				});
			}
		}
	}, 3000);
}

setTimeout(function() {
	updateMonitorRef();
}, 7000);


var firebaseHelper = {
	processUser: function() {
		globalFirebaseUser = firebaseApp.auth().currentUser;
		if (isPrerenderSearchEngine) {
			globalFirebaseUser = {
				uid: "_escaped_fragment_"
			};
			return;
		}
		updateMonitorRef();
		globalFirebaseUserLinkedProviders = {
			"google.com": false,
			"facebook.com": false,
			"twitter.com": false
		};
		if (globalFirebaseUser) {
			var providerData = globalFirebaseUser.providerData;
			providerData.map(function(item) {
				globalFirebaseUserLinkedProviders[item.providerId] = true;
			});
		}
	},
	redirectLogin: function(p, action) {
		var ref = ssoOrigin + "/login.html?ref=" + encodeURI(window.location.href) + "&p=" + p + "&action=" + action;
		console.log("ref:", ref);
		window.location.href = ref;
	},
	popupLogin: function(p) {
		var provider;
		if (p === "g") {
			provider = new firebase.auth.GoogleAuthProvider();
		} else if (p === "f") {
			provider = new firebase.auth.FacebookAuthProvider();
		} else if (p === "t") {
			provider = new firebase.auth.TwitterAuthProvider();
		}
		return firebase.auth().signInWithPopup(provider).then(function(result) {
			var token = result.credential.accessToken;
			var user = result.user;
			firebaseHelper.processUser();
			return Q.resolve({
				"status": "SUCCESS"
			});
		}).catch(function(error) {
			firebaseHelper.processUser();
			var errorCode = error.code;
			var errorMessage = error.message;
			alert(error.message);
			var email = error.email;
			var credential = error.credential;
			console.error(error);
			alert(error.message);
		});
	},
	popupLink: function(p) {
		var provider;
		if (p === "g") {
			provider = new firebase.auth.GoogleAuthProvider();
		} else if (p === "f") {
			provider = new firebase.auth.FacebookAuthProvider();
		} else if (p === "t") {
			provider = new firebase.auth.TwitterAuthProvider();
		}
		return firebase.auth().currentUser.linkWithPopup(provider).then(function(result) {
			var token = result.credential.accessToken;
			var user = result.user;
			firebaseHelper.processUser();
			return Q.resolve({
				"status": "SUCCESS"
			});
		}).catch(function(error) {
			firebaseHelper.processUser();
			var errorCode = error.code;
			var errorMessage = error.message;
			var email = error.email;
			var credential = error.credential;
			console.error(error);
			alert(error.message);
		});
	},
	loginWithEmailPassword: function(form) {
		return firebase.auth().signInWithEmailAndPassword(form.email, form.password)
			.then(function() {
				return Q.resolve({
					"status": "SUCCESS"
				});
			}).catch(function(error) {
				console.error(error);
				return Q.reject(error);
			});
	},
	updateAnonymousUser: function(user) {
		if (globalFirebaseUser && globalFirebaseUser.isAnonymous) {
			var credential = firebase.auth.EmailAuthProvider.credential(user.email, user.password);
			return globalFirebaseUser.link(credential)
				.then(function(firebaseUser) {}).then(function() {
					return Q.resolve({});
				}).catch(function(error) {
					return Q.reject(error);
				});
		} else {
			return Q.reject({
				error: "user is not anonymous"
			});
		}
	},
	resetPassword: function(email) {
		return firebase.auth().sendPasswordResetEmail(email).then(function(result) {
			return Q.resolve({
				result: result
			})
		}).catch(function(error) {
			return Q.reject(error);
		});
	},
	signOut: function() {
		console.log("firebaseHelper.signOut();");
		firebase.auth().signOut().then(function(result) {
			// firebaseHelper.signInAnonymously();
		}, function(error) {
			console.log("firebaseHelper.signOut() error:");
			console.log(error);
		});
	},
	signInWithCustomToken: function(token) {
		return firebase.auth().signInWithCustomToken(token)
			.then(function() {
				return Q.resolve({})
			}).catch(function(error) {
				return Q.reject(error)
			});
	},
	init: function() {
		if (isFirebaseInitialized) {
			return;
		}
		isFirebaseInitialized = true;

		firebaseApp = firebase.initializeApp(firebaseConfig);

		firebaseHelper.waitForSignIn().then(function() {
			firebaseHelper.processUser();
			if (firebaseApp.auth().currentUser === null) {
				// console.log("firebaseApp.auth().currentUser is null");
				// firebaseHelper.signInAnonymously();
			} else {
				// console.log("firebaseApp.auth().currentUser is not null");
			}

			angular.element(function() {
				angular.bootstrap(document, ['angularhadiyemek']);
			});

		});
	},
	waitForSignIn: function() {
		var auth = firebase.auth();
		return new firebase.Promise(function(resolve) {
			var off;

			function callback() {
				off();
				resolve();
			}
			off = auth.onAuthStateChanged(callback);
		});
	},
	requireSignIn: function(rejectIfAuthDataIsNull) {
		return firebaseHelper.waitForSignIn().then(function() {
			var authData = firebase.auth().currentUser,
				res = null;
			if (rejectIfAuthDataIsNull && authData === null) {
				res = Q.reject("AUTH_REQUIRED");
			} else {
				res = Q.when(authData);
			}
			return res;
		});
	}
};

firebaseHelper.init();

var salesRepresentativeHelpers = {
    isSalesRepresentative: false,
    checkSalesRepresentativeStatus: function () {
        if(!globalFirebaseUser){
            return Q.resolve(false);
        }
        return dataLib.getUserReadOnlyBySalesRepresentativeInfoRef(globalFirebaseUser.uid)
            .child('CURRENT_SalesRepresentative_STATUS')
            .once('value')
            .then(function (snapshot) {
                var status = snapshot.val();
                salesRepresentativeHelpers.isSalesRepresentative = (status === CONSTANTS_SalesRepresentative_STATUSES.APPROVED);
                on_IsSalesRepresentative_valueChange();
                return Q.resolve(salesRepresentativeHelpers.isSalesRepresentative);
            });
    },
    startAutoChecks: function () {
        firebase.auth().onAuthStateChanged(function(user) {
            if (user) {
                salesRepresentativeHelpers.checkSalesRepresentativeStatus();
            }else{
                salesRepresentativeHelpers.isSalesRepresentative = false;
                on_IsSalesRepresentative_valueChange();
            }
        });
    }
}

setTimeout(function () {
    salesRepresentativeHelpers.startAutoChecks();
}, 1000);

"use strict";

var globalLocalLatestBranchId;
// firebase.database().ref('users/' + currentAuth.uid);
// var branchsRef = userRef.child('restaurant_apps/adminOf/branchs');
var dataLib = {
	root: null,
	storage: null,
	getRoot: function() {
		if (!dataLib.root) {
			dataLib.root = firebase.database().ref();
		}
		return dataLib.root;
	},
	webAppData: null,
	appData: null,

	///////////////REF START////////////
	getWebAppDataRef: function() {
		return dataLib.getRoot().child("restaurant_apps/webApps");
	},
	getAppRef: function() {
		return dataLib.getRoot().child("restaurant_apps/apps");
	},
	getAppByIdRef: function(appId) {
		return dataLib.getAppRef().child(appId);
	},

	getAppExpireDateRef: function(appId) {
		return dataLib
			.getAppByIdRef(appId)
			.child("packetInfo/existingPacket/validUntilTo");
	},
	getOrdersRef: function() {
		return dataLib.getRoot().child("restaurant_apps/orders");
	},
	getOrderByIdRef: function(id) {
		return dataLib
			.getRoot()
			.child("restaurant_apps/orders")
			.child(id);
	},
	getOrdersByOrderKeys: function(orderKeys) {
		var orders = {};
		var promises = [];
		for (var orderKey in orderKeys) {
			promises[promises.length] = dataLib
				.getOrderByIdRef(orderKey)
				.once("value");
		}
		return Q.all(promises).then(function(resultSnaps) {
			var reversedOrders = [];
			var resultIndex = 0;
			for (var orderKey in orderKeys) {
				orders[orderKey] = resultSnaps[resultIndex].val();
				orders[orderKey].orderKey = orderKey;

				reversedOrders[reversedOrders.length] = orders[orderKey];
				resultIndex++;
			}
			return Q.resolve(reversedOrders.reverse());
		});
	},
	getAppPublicByIdRef: function(id) {
		return dataLib
			.getRoot()
			.child("restaurant_apps/apps")
			.child(id + "/public");
	},
	getAppStepsCheckListByIdRef: function(id) {
		return dataLib
			.getRoot()
			.child("restaurant_apps/apps")
			.child(id + "/stepsCheckList");
	},
	getAppStepsCheckListStatusByIdRef: function(id) {
		return dataLib
			.getRoot()
			.child("restaurant_apps/apps")
			.child(id + "/stepsCheckListStatus");
	},
	getAppPagesByIdRef: function(id) {
		return dataLib
			.getRoot()
			.child("restaurant_apps/apps")
			.child(id + "/pages");
	},
	getAppPublicNameByIdRef: function(id) {
		return dataLib.getAppPublicByIdRef(id).child("name");
	},
	getAppPublicHostnameByIdRef: function(id) {
		return dataLib.getAppPublicByIdRef(id).child("hostname");
	},
	getAppPublicIsInDevelopmentModeRef: function(id) {
		return dataLib.getAppPublicByIdRef(id).child("isInDevelopmentMode");
	},
	getAppHasValidOwnerRef: function(id) {
		return dataLib.getAppByIdRef(id).child("hasValidOwner");
	},
	// getAppPublicPrimaryDomainRef: function(id) {
	//   return dataLib.getAppPublicByIdRef(id).child("primaryDomain");
	// },
	getAppPublicCampaignsByIdRef: function(appId) {
		return dataLib.getAppPublicByIdRef(appId).child("campaigns");
	},
	getPageByIdRef: function(appId, pageId) {
		return dataLib.getAppPagesByIdRef(appId).child(pageId);
	},
	getBranchsRef: function() {
		return dataLib.getRoot().child("restaurant_apps/branchs");
	},

	getUserReadOnlyBySalesRepresentativeInfoRef: function (uid) {
		return dataLib
			.getRoot()
			.child("salesRepresentative")
			.child(uid).child("readOnlyBySalesRepresentativeInfo");
	},
	getSalesRepresentativeBranchsRef: function (uid) {
		return dataLib
			.getUserReadOnlyBySalesRepresentativeInfoRef(uid)
			.child("adminOf/branchs")
	},
	getBranchsOfUser: function() {
		var user = firebase.auth().currentUser;
		var branchKeys = {};

		var promises = [];
		promises[promises.length] = dataLib.getBranchsOfAdmin(user.uid).once("value")
		if(salesRepresentativeHelpers.isSalesRepresentative){
			promises[promises.length] = dataLib.getSalesRepresentativeBranchsRef(user.uid).once("value")
		}
		return Q.all(promises)
			.then(function(results) {
				for(var index in results){
					branchKeys = Object.assign(
						branchKeys,
						(results[index].val() || {})
					);
				}

				var promises = [];
				for (var branchKey in branchKeys) {
					promises[promises.length] = dataLib.getBranchPublicNameObjById(
						branchKey
					);
				}
				return Q.all(promises);
			})
			.then(function(results) {
				var resultIndex = 0;
				for (var branchKey in branchKeys) {
					var obj = results[resultIndex];
					branchKeys[branchKey] = obj;
					resultIndex++;
				}
				return Q.resolve(branchKeys);
			});
	},

	getBranchRefById: function(id) {
		return dataLib.getBranchsRef().child(id);
	},

	getBranchCurrentOrdersRefById: function(id) {
		return dataLib.getBranchRefById(id).child("lists/currentOrders");
	},

	getBranchFinishedOrdersRefById: function(id) {
		return dataLib.getBranchRefById(id).child("lists/finishedOrders");
	},

	getBranchOrdersRefById: function(id) {
		return dataLib.getBranchRefById(id).child("lists/orders");
	},

	getBranchListsRefById: function(id) {
		return dataLib.getBranchRefById(id).child("lists");
	},

	getBranchPublicBranchStatusRefById: function(id) {
		return dataLib
			.getBranchsRef()
			.child(id)
			.child("public/branchStatus");
	},

	getBranchMasterStatusRefById: function(id) {
		return dataLib
			.getBranchsRef()
			.child(id)
			.child("masterStatus");
	},

	getBranchPublicNameObjById: function(id) {
		var name;
		var appName;
		var city;
		var appId;

		return dataLib
			.getBranchRefById(id)
			.child("public/name")
			.once("value")
			.then(function(nameSnap) {
				name = nameSnap.val();
				return dataLib
					.getBranchRefById(id)
					.child("public/appName")
					.once("value");
			})
			.then(function(appNameSnap) {
				appName = appNameSnap.val();
				return dataLib
					.getBranchRefById(id)
					.child("public/city")
					.once("value");
			})
			.then(function(citySnap) {
				city = citySnap.val();
				return dataLib
					.getBranchRefById(id)
					.child("public/appId")
					.once("value");
			})
			.then(function(appIdSnap) {
				appId = appIdSnap.val();
				return Q.resolve({
					name: name ? name : "",
					appName: appName ? appName : "",
					city: city ? city : "",
					branchKey: id,
					appId: appId
				});
			});
	},

	allDistrictsRef: function() {
		return dataLib
			.getRoot()
			.child("hadiyemek-districts");
	},
	allCitiesListRef: function() {
		return dataLib.getRoot().child("citiesList");
	},
	globalPaymentTypesRef: function() {
		return dataLib.getRoot().child("restaurant_apps/paymentTypes");
	},
	getBranchDistrictsByBranchIdRef: function(id) {
		return dataLib.getBranchRefById(id).child("/public/config/districts");
	},
	getBranchDeliveryTimeByBranchIdRef: function(id) {
		return dataLib.getBranchRefById(id).child("/public/config/deliveryTime");
	},
	getBranchPaymentTypesByBranchIdRef: function(id) {
		return dataLib.getBranchRefById(id).child("/public/config/paymentType");
	},
	getUserRef: function(uid) {
		return dataLib
			.getRoot()
			.child("users")
			.child(uid);
	},
	getCurrentCreditRef: function(uid, appId) {
		return dataLib
			.getUserRef(uid)
			.child(
				"restaurant_apps/earnedCreditsWithOrders/" + appId + "/currentCredit"
			);
	},
	getUserRememberDataRef: function(uid) {
		return dataLib.getUserRef(uid).child("restaurant_apps/rememberData");
	},
	getUserAppAdminRef: function(uid) {
		return dataLib
			.getUserRef(uid)
			.child("restaurant_apps/adminOf/apps")
			.child(dataLib.webAppData.appId);
	},
	getBranchsOfAdmin: function(uid) {
		return dataLib.getUserRef(uid).child("restaurant_apps/adminOf/branchs");
	},
	getUserAppsByUserIdRef: function(uid) {
		return dataLib.getUserRef(uid).child("restaurant_apps/adminOf/apps");
	},
	getLatestDistrictFromGlobalRememberDataRef: function(uid) {
		return dataLib.getUserRememberDataRef(uid).child("latestDistrict");
	},
	getUserRememberDataInWebAppLatestRef: function(uid, appId) {
		return dataLib
			.getUserRememberDataRef(uid)
			.child("inWebAppLatest")
			.child(appId);
	},
	getBucketRef: function(uid, branchId) {
		return dataLib
			.getUserRef(uid)
			.child("restaurant_apps/buckets/branchs/" + branchId + "/bucket");
	},
	getBranchWorkingHoursByBranchIdRef: function(id) {
		return dataLib.getBranchRefById(id).child("/public/config/workingHours");
	},
	getBranchCategoriesByBranchIdRef: function(id) {
		return dataLib.getBranchRefById(id).child("/public/categories");
	},
	getBranchProductsByBranchIdRef: function(id) {
		return dataLib.getBranchRefById(id).child("/public/products");
	},
	getBranchProductOptionsByBranchIdRef: function(id) {
		return dataLib.getBranchRefById(id).child("/public/productOptions");
	},
	getBranchConfigBranchIdRef: function(id) {
		return dataLib.getBranchRefById(id).child("/public/config");
	},
	getBranchPublicRef: function(id) {
		return dataLib.getBranchRefById(id).child("public");
	},
	getCategoriesRef: function() {
		return dataLib.getRoot().child("restaurant_apps/categories");
	},
	getProductsRef: function() {
		return dataLib.getRoot().child("restaurant_apps/products");
	},
	getProductOptionsRef: function() {
		return dataLib.getRoot().child("restaurant_apps/productOptions");
	},
	getBranchLocationDistrictIdByBranchIdRef: function(id) {
		return dataLib.getBranchRefById(id).child("/public/branchLocationDistrict");
	},
	getGlobalUserDataRef: function(uid) {
		return dataLib.getUserRef(uid).child("globalUserData");
	},
	getVerifiedNumbersRef: function(uid) {
		return dataLib.getUserRef(uid).child("verifiedNumbers");
	},
	getTempPaymentResultRef: function(uid) {
		return dataLib.getUserRef(uid).child("tempPaymentResult");
	},
	getAddressesWithDeliveryDistrictRef: function(id) {
		return dataLib.getGlobalUserDataRef(id).child("addressesWithDeliveryDistrict");
	},

	///////////////REF END////////////

	///////////////METHODS START////////////
	getWebAppData: function() {
		if (dataLib.webAppData) {
			return Q.resolve(dataLib.webAppData);
		} else {
			var webRef = util.getAppId();
			return dataLib
				.getWebAppDataRef()
				.child(webRef)
				.once("value")
				.then(function(snapshot) {
					dataLib.webAppData = snapshot.val();
					if (dataLib.webAppData === null) {
						alert("This website could not found!");
						window.top.location.href = "http://www.hadiyemek.com";
					}
					return Q.resolve(dataLib.webAppData);
				})
				.catch(function(error) {
					console.log("dataLib.getWebAppData failed: ", error);
					return Q.resolve(error);
				});
		}
	},
	getAppData: function(appId) {
		// if (dataLib.appData) {
		// 	return Q.resolve(dataLib.appData);
		// } else {
		return dataLib
			.getAppPublicByIdRef(appId)
			.once("value")
			.then(function(snapshot) {
				dataLib.appData = snapshot.val();
				return Q.resolve(dataLib.appData);
			})
			.catch(function(error) {
				console.log("dataLib.getAppData failed: ", error);
				return Q.reject(error);
			});
		// }
	},
	///////////////METHODS END////////////

	///////////////Districts UTILS START////////////
	addBranchIdPropertyToDistricts: function(districts, branchId) {
		for (var districtKey in districts) {
			districts[districtKey].key = districtKey;
			districts[districtKey].branchId = branchId;
			districts[districtKey].outwardCode = districtKey.split('-')[0];
		}
		return districts;
	},
	setLatestDistrict: function(district) {
		return dataLib
			.getUserRememberDataRef(globalFirebaseUser.uid)
			.child("latestDistrict")
			.set(district.key)
			.then(function() {
				return dataLib
					.getUserRememberDataInWebAppLatestRef(
						globalFirebaseUser.uid,
						dataLib.webAppData.appId
					)
					.child("latestDistrict")
					.set(district.key);
			});
	},
	getLatestDistrictId: function() {
		var districtId = null;
		return dataLib
			.getLatestDistrictFromGlobalRememberData()
			.then(function(districtIdResult) {
				if (districtIdResult) {
					districtId = districtIdResult;
				}
				return dataLib.getUserRememberDataInWebAppLatest();
			})
			.then(function(val) {
				var rememberData = val;
				if (rememberData && rememberData.latestDistrict) {
					districtId = rememberData.latestDistrict;
				}
				return Q.resolve(districtId);
			})
			.catch(function(error) {
				return Q.reject(error);
			});
	},
	///////////////Districts UTILS END//////////////

	///////////////PAGES START//////////////
	getPageById: function(pageId) {
		return dataLib
			.getPageByIdRef(dataLib.webAppData.appId, pageId)
			.once("value")
			.then(function(snap) {
				return Q.resolve(snap.val());
			})
			.catch(function(error) {
				return Q.reject(error);
			});
	},
	///////////////PAGES END//////////////

	///////////////CREDITS START//////////////
	getCurrentCredit: function() {
		return dataLib
			.getCurrentCreditRef(globalFirebaseUser.uid, dataLib.webAppData.appId)
			.once("value")
			.then(function(snap) {
				var val = snap.val();
				if (val) {
					return Q.resolve(val);
				} else {
					return Q.resolve(0);
				}
			});
	},
	getVerifiedNumbers: function() {
		return dataLib
			.getVerifiedNumbersRef(globalFirebaseUser.uid)
			.once("value")
			.then(function(snap) {
				var val = snap.val();
				return Q.resolve(val);
			});
	},
	///////////////CREDITS END////////////////

	///////////////Bucket and branch helpers START//////////////
	getDistrictsOfCurrentBranch: function() {
		return dataLib
			.getLatestBranchId()
			.then(function(branchId) {
				return dataLib.getBranchDistrictsByBranchIdRef(branchId).once("value");
			})
			.then(function(districtSnap) {
				return Q.resolve(districtSnap.val());
			});
	},
	getLatestDistrictFromGlobalRememberData: function() {
		return dataLib
			.getLatestDistrictFromGlobalRememberDataRef(globalFirebaseUser.uid)
			.once("value")
			.then(function(snap) {
				return Q.resolve(snap.val());
			})
			.catch(function(error) {
				return Q.reject(error);
			});
	},
	getUserRememberDataInWebAppLatest: function() {
		return dataLib
			.getUserRememberDataInWebAppLatestRef(
				globalFirebaseUser.uid,
				dataLib.webAppData.appId
			)
			.once("value")
			.then(function(snap) {
				return Q.resolve(snap.val());
			})
			.catch(function(error) {
				return Q.reject(error);
			});
	},
	setLatestBranchId: function(branchId) {
		globalLocalLatestBranchId = branchId;
		return dataLib
			.getUserRememberDataInWebAppLatestRef(
				globalFirebaseUser.uid,
				dataLib.webAppData.appId
			)
			.child("/latestBranchId")
			.set(branchId);
	},
	getLatestBranchId: function() {
		if (globalLocalLatestBranchId) {
			return Q.resolve(globalLocalLatestBranchId);
		} else {
			return dataLib
				.getUserRememberDataInWebAppLatest()
				.then(function(val) {
					var rememberData = val;
					var branchId = dataLib.getFirstBranch();
					if (rememberData && rememberData.latestBranchId) {
						branchId = rememberData.latestBranchId;
					}
					dataLib.setLatestBranchId(branchId);
					return Q.resolve(branchId);
				})
				.catch(function(error) {
					return Q.reject(error);
				});
		}
	},
	getFirstBranch: function() {
		var branchId = Object.keys(dataLib.appData.webPathsBranchMap)[0];
		if (!branchId) {
			alert("0 branch error");
		}
		return branchId;
	},
	isBranchOpenNow: function() {
		return dataLib
			.getLatestBranchId()
			.then(function(branchId) {
				return dataLib
					.getBranchWorkingHoursByBranchIdRef(branchId)
					.once("value");
			})
			.then(function(workingHoursSnap) {
				var workingHours = workingHoursSnap.val();
				return Q.resolve(dataLib.isOpenTodayHelper(workingHours));
			});
	},
	isOpenTodayHelper: function(workingHours) {
		var now = new Date();
		var todayConfig = workingHours[now.getDay()];

		if (!todayConfig) {
			return false;
		}

		var startDate = new Date(now);
		var endDate = new Date(now);
		startDate.setHours(todayConfig.start.hour);
		startDate.setMinutes(todayConfig.start.minute);
		endDate.setHours(todayConfig.end.hour);
		endDate.setMinutes(todayConfig.end.minute);

		var yesterday = new Date(now);
		yesterday.setDate(yesterday.getDate() - 1);
		var yesterdayConfig = workingHours[yesterday.getDay()];

		var yesterdayStartDate = new Date(now);
		yesterdayStartDate.setHours(0);
		yesterdayStartDate.setMinutes(0);

		var yesterdayEndDate = new Date(now);
		yesterdayEndDate.setHours(yesterdayConfig.end.hour);
		yesterdayEndDate.setMinutes(yesterdayConfig.end.minute);

		var todayEndForNew = new Date(yesterdayStartDate);
		todayEndForNew.setDate(todayEndForNew.getDate() + 1);

		if (moment(endDate).isBefore(startDate)) {
			if (
				parseInt(yesterdayConfig.end.hour) <
				parseInt(yesterdayConfig.start.hour)
			) {
				return (
					(yesterdayConfig.isOpen &&
						moment(now).isBetween(yesterdayStartDate, yesterdayEndDate)) ||
					(todayConfig.isOpen &&
						moment(now).isBetween(startDate, todayEndForNew))
				);
			} else {
				return (
					todayConfig.isOpen && moment(now).isBetween(startDate, todayEndForNew)
				);
			}
		} else if (
			parseInt(yesterdayConfig.end.hour) < parseInt(yesterdayConfig.start.hour)
		) {
			return (
				(yesterdayConfig.isOpen &&
					moment(now).isBetween(yesterdayStartDate, yesterdayEndDate)) ||
				(todayConfig.isOpen && moment(now).isBetween(startDate, todayEndForNew))
			);
		}
		return todayConfig.isOpen && moment(now).isBetween(startDate, endDate);
	},
	///////////////Bucket and branch helpers END//////////////

	////////////////CATEGORIES START////////////////////////
	getProduct: function(productId) {
		var product;
		return dataLib
			.getProductsRef()
			.child(productId)
			.once("value")
			.then(function(pSnap) {
				product = pSnap.val();
				if (!product) {
					product = {};
				}
				product.key = productId;
				return dataLib.getProductOptionsPromises(product);
			})
			.then(function(promisesResults) {
				product.productOptions = {};
				for (var i = 0; i < promisesResults.length; i++) {
					var productOption = promisesResults[i];
					product.productOptions[productOption.key] = productOption;
				}
				return Q.resolve(product);
			});
	},
	getProductOption: function(pKey) {
		return dataLib
			.getProductOptionsRef()
			.child(pKey)
			.once("value")
			.then(function(snap) {
				var option = snap.val();
				option.key = pKey;
				return Q.resolve(option);
			});
	},
	getProductsPromises: function(category) {
		var promises = [];
		var products = category.products;
		for (var pKey in products) {
			promises[promises.length] = dataLib.getProduct(pKey);
		}
		return Q.all(promises);
	},
	getProductOptionsPromises: function(product) {
		var promises = [];
		var productOptions = product.productOptions;
		for (var pKey in productOptions) {
			promises[promises.length] = dataLib.getProductOption(pKey);
		}
		return Q.all(promises);
	},
	getProducts: function(category) {
		return dataLib
			.getProductsPromises(category)
			.then(function(promises) {
				for (var i = 0; i < promises.length; i++) {
					var product = promises[i];
					category.products[product.key] = product;
				}
				return Q.resolve(category);
			})
			.catch(function(error) {
				console.log("getProducts failed: ", error);
			});
	},
	getProductOptions: function(product) {
		return dataLib
			.getProductOptionsPromises(product)
			.then(function(promises) {
				for (var i = 0; i < promises.length; i++) {
					var productOption = promises[i];
					product.productOptions[productOption.key] = productOption;
				}
				return Q.resolve(product);
			})
			.catch(function(error) {
				console.log("getProductOptions failed: ", error);
			});
	},
	getProductOptionsByBranchId: function(id) {
		return dataLib
			.getBranchProductOptionsByBranchIdRef(id)
			.once("value")
			.then(function(snap) {
				var productOptionsIds = snap.val();
				var promises = [];
				for (var pKey in productOptionsIds) {
					promises[promises.length] = dataLib.getProductOption(pKey);
				}
				return Q.all(promises);
			})
			.then(function(promises) {
				var productOptions = {};
				for (var i = 0; i < promises.length; i++) {
					var productOption = promises[i];
					productOptions[productOption.key] = productOption;
				}
				return Q.resolve(productOptions);
			});
	},
	getProductsByBranchId: function(id) {
		var products;
		return dataLib
			.getBranchProductsByBranchIdRef(id)
			.once("value")
			.then(function(snap) {
				var productsIds = snap.val();
				var promises = [];
				for (var pKey in productsIds) {
					promises[promises.length] = dataLib.getProduct(pKey);
				}
				return Q.all(promises);
			})
			.then(function(promises) {
				products = {};
				for (var i = 0; i < promises.length; i++) {
					var product = promises[i];
					products[product.key] = product;
				}
				return Q.resolve(products);
			})
			.then(function(products) {
				var promises = [];
				for (var key in products) {
					promises[promises.length] = dataLib.getProductOptions(products[key]);
				}
				return Q.all(promises);
			})
			.then(function(getProductOptionsPromises) {
				return Q.resolve(products);
			});
	},
	getCatagoriesByBranchId: function(id) {
		var categories;
		return dataLib
			.getBranchCategoriesByBranchIdRef(id)
			.once("value")
			.then(function(snap) {
				categories = snap.val();
				if (!categories) {
					categories = {};
				}
				var promises = [];
				for (var categoryKey in categories) {
					promises[promises.length] = dataLib
						.getCategoriesRef()
						.child(categoryKey)
						.once("value");
				}
				return Q.all(promises);
			})
			.then(function(results) {
				var keyArray = Object.keys(categories);
				for (var i = 0; i < results.length; i++) {
					var key = keyArray[i];
					categories[key] = results[i].val();
				}
				return Q.resolve(categories);
			})
			.then(function(categories) {
				var promises = [];
				for (var key in categories) {
					promises[promises.length] = dataLib.getProducts(categories[key]);
				}
				return Q.all(promises);
			})
			.then(function(getProductsPromises) {
				return Q.resolve(categories);
			});
	},
	////////////////CATEGORIES END//////////////////////////

	////////////////BRANCH DETAILS START//////////////////////////
	getBranchLocationDistrictIdByBranchId: function(id) {
		var districtId;
		return dataLib
			.getBranchLocationDistrictIdByBranchIdRef(id)
			.once("value")
			.then(function(snap) {
				districtId = snap.val();
				return dataLib
					.allDistrictsRef()
					.child(districtId)
					.once("value");
			})
			.then(function(snap) {
				var districtObj = snap.val();
				districtObj.key = districtId;
				return Q.resolve(districtObj);
			});
	},
	getPaymentsByBranchId: function(id) {
		var paymentTypeIds;
		return dataLib
			.getBranchPaymentTypesByBranchIdRef(id)
			.once("value")
			.then(function(snap) {
				paymentTypeIds = snap.val();
				var promises = [];
				for (var paymentTypeId in paymentTypeIds) {
					promises[promises.length] = dataLib
						.globalPaymentTypesRef()
						.child(paymentTypeId)
						.once("value");
				}
				return Q.all(promises);
			})
			.then(function(results) {
				var keyArray = Object.keys(paymentTypeIds || {});
				for (var i = 0; i < results.length; i++) {
					var key = keyArray[i];
					paymentTypeIds[key] = results[i].val();
				}
				return Q.resolve(paymentTypeIds);
			})
			.catch(function(error) {
				console.error("getPaymentsByBranchId failed: ", error);
				alert(JSON.stringify(error));
			});
	},

	////////////////BRANCH DETAILS END//////////////////////////

	//////////////////ORDER ADDRESS START /////////////////////
	setNewTheme: function(theme) {
		var appRef = dataLib.getAppPublicByIdRef(dataLib.webAppData.appId);
		return appRef
			.child("customNewTheme")
			.set(theme)
			.then(function(result) {
				return appRef.child("themeName").set("customNewTheme");
			})
			.then(function(result) {
				return Q.resolve(result);
			})
			.catch(function(error) {
				return Q.reject(error);
			});
	},
	setNewThemeWithAppId: function(appId, theme) {
		var appRef = dataLib.getAppPublicByIdRef(appId);
		return appRef
			.child("customNewTheme")
			.set(theme)
			.then(function(result) {
				return appRef.child("themeName").set("customNewTheme");
			})
			.then(function(result) {
				return Q.resolve(result);
			})
			.catch(function(error) {
				return Q.reject(error);
			});
	},
	//////////////////ORDER ADDRESS END ///////////////////////

	//////////////////BG IMAGE START ///////////////////////
	setBgImage: function(appId, bgObj) {
		return dataLib
			.getAppPublicByIdRef(appId)
			.child("webBgStyle")
			.set(bgObj);
	},
	setLogo: function(appId, imageUrl) {
		return dataLib
			.getAppPublicByIdRef(appId)
			.child("webLogo")
			.set(imageUrl);
	},
	setCampaigns: function(appId, campaigns) {
		return dataLib
			.getAppPublicByIdRef(appId)
			.child("campaigns")
			.set(campaigns);
	},
	//////////////////BG IMAGE END ///////////////////////

	//////////////////SEARCH CITY////////////////
	getDistrictsByCityName: function(cityName) {
		return dataLib
			.allDistrictsRef()
			.orderByChild("cityURLify")
			.equalTo(URLify(cityName))
			.once("value")
			.then(function(snap) {
				var districts = snap.val();
				if (!districts) {
					return Q.reject({
						message: "semt bulunamadı"
					});
				}
				for (var key in districts) {
					districts[key].key = key;
				}
				return Q.resolve(districts);
			});
	}
	//////////////////SEARCH CITY////////////////
};

'use strict';

var CONSTANTS_SSO = {
	"setSsoUserCookieDirectly": "setSsoUserCookieDirectly",
	"sendMeVerificationCode": "sendMeVerificationCode",
	"verifySmsCode": "verifySmsCode",
	"checkSsoCookie": "checkSsoCookie",
	"setSsoUser": "setSsoUser",
	"getSsoUser": "getSsoUser",
	"signOutSsoUserAndReturnNewUser": "signOutSsoUserAndReturnNewUser",
	"setCookieAndRedirectBack": "setCookieAndRedirectBack",
	"processSmsToken": "processSmsToken",
}

var apiHelper = {
	requestWithUserPost: function(url, reqObj) {
		if (!firebase.auth().currentUser) {
			throw new Error("firebase.auth().currentUser is null. Can not request with user.");
		}
		return firebase.auth().currentUser.getIdToken()
			.then(function(idToken) {
				return apiHelper.requestPost(url, reqObj, idToken);
			});
	},
	requestPost: function(url, reqObj, idToken) {
		var deferred = Q.defer();

		var headers = {};
		if (idToken) {
			headers['Authorization'] = idToken;
		}

		var request = ajax({
			headers: headers,
			withCredentials: true
		})

		request.post(url, reqObj)
			.then(function(response, xhr) {
				deferred.resolve(response);
			})
			.catch(function(err, xhr) {
				deferred.reject(err);
			});

		return deferred.promise;
	},
	getBaseUrl: function() {
		var baseUrl = API_END_POINTS.GOOGLE_CLOUD_BASE;
		if (window.location.host.indexOf("localhost") !== -1) {
			baseUrl = API_END_POINTS.GOOGLE_CLOUD_LOCAL_BASE;
		}
		return baseUrl;
	},
	checkSsoCookie: function() {
		var url = apiHelper.getBaseUrl() + CONSTANTS_SSO.checkSsoCookie;
		return apiHelper.requestPost(url, {}, false);
	},
	redirectToSetCookie: function() {
		window.top.location.replace(apiHelper.getBaseUrl() + CONSTANTS_SSO.setCookieAndRedirectBack);
	},
	getSsoUser: function() {
		var url = apiHelper.getBaseUrl() + CONSTANTS_SSO.getSsoUser;
		return apiHelper.requestPost(url, {}, false);
	},
	signOutSsoUserAndReturnNewUser: function() {
		var url = apiHelper.getBaseUrl() + CONSTANTS_SSO.signOutSsoUserAndReturnNewUser;
		return apiHelper.requestPost(url, {}, false);
	},
	setSsoUser: function() {
		var url = apiHelper.getBaseUrl() + CONSTANTS_SSO.setSsoUser;
		return apiHelper.requestWithUserPost(url, {});
	},
	setSsoUserCookieDirectly: function() {
		var url = apiHelper.getBaseUrl() + CONSTANTS_SSO.setSsoUserCookieDirectly;
		return apiHelper.requestWithUserPost(url, {});
	},
	sendMeVerificationCode: function(params) {
		var url = apiHelper.getBaseUrl() + CONSTANTS_SSO.sendMeVerificationCode;
		return apiHelper.requestWithUserPost(url, params);
	},
	verifySmsCode: function(params) {
		var url = apiHelper.getBaseUrl() + CONSTANTS_SSO.verifySmsCode;
		return apiHelper.requestWithUserPost(url, params);
	},
	processSmsToken: function(params) {
		var url = apiHelper.getBaseUrl() + CONSTANTS_SSO.processSmsToken;
		return apiHelper.requestPost(url, params);
	},
};

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, angularhadiyemekGenerator, angularhadiyemekConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        angularhadiyemekGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( angularhadiyemekConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, angularhadiyemekConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        //
        angularhadiyemekConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

var GLOBAL_EMBEDDED_EXPO;
var EMBED_EXPO_PUSH_TOKEN_CODE;

var paramsForEmbeded = util.getParamsObj();
if (paramsForEmbeded["GLOBAL_EMBEDDED_EXPO"] === "true") {
  GLOBAL_EMBEDDED_EXPO = true;
}

if (
  paramsForEmbeded["EMBED_EXPO_PUSH_TOKEN_CODE"] &&
  paramsForEmbeded["EMBED_EXPO_PUSH_TOKEN_CODE"] !== ""
) {
  EMBED_EXPO_PUSH_TOKEN_CODE = paramsForEmbeded["EMBED_EXPO_PUSH_TOKEN_CODE"];
}

(function() {
  "use strict";

  angular.module("angularhadiyemek").run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $timeout, $state, $mdDialog, $location) {

    moment.locale("tr");
    $rootScope.global = {};
    $rootScope.global.title = "Otomatik sipariş yazdırma yazılımı | hadiyemek.com";

    moment.tz.setDefault("Europe/Istanbul");

    $rootScope.global.GLOBAL_EMBEDDED_EXPO = true;

    // $timeout(function() {
    //   checkMobilSettings();
    // }, 1000);

    // $timeout(function() {
    //   checkMobilSettings();
    // }, 5000);

    // $timeout(function() {
    //   checkMobilSettings();
    // }, 10000);
    // $timeout(function() {
    //   checkMobilSettings();
    // }, 15000);

    // $timeout(function() {
    //   checkMobilSettings();
    // }, 30000);

    // $timeout(function() {
    //   checkMobilSettings();
    // }, 60000);

    // function checkMobilSettings() {
    //   if (GLOBAL_EMBEDDED_EXPO) {
    //     $rootScope.global.GLOBAL_EMBEDDED_EXPO = GLOBAL_EMBEDDED_EXPO;
    //     if (EMBED_EXPO_PUSH_TOKEN_CODE) {
    //       EMBED_EXPO_PUSH_TOKEN_CODE = EMBED_EXPO_PUSH_TOKEN_CODE.replace('%5B','[');
    //       EMBED_EXPO_PUSH_TOKEN_CODE = EMBED_EXPO_PUSH_TOKEN_CODE.replace('%5D',']');

    //       console.log("EMBED_EXPO_PUSH_TOKEN_CODE");
    //       console.log(EMBED_EXPO_PUSH_TOKEN_CODE);
    //       $rootScope.global.GLOBAL_EMBEDDED_EXPO_TEXT = EMBED_EXPO_PUSH_TOKEN_CODE;
    //       $rootScope.global.EMBED_EXPO_PUSH_TOKEN_CODE = EMBED_EXPO_PUSH_TOKEN_CODE;

    //       localStorage.setItem(
    //         "EMBED_EXPO_PUSH_TOKEN_CODE",
    //         EMBED_EXPO_PUSH_TOKEN_CODE
    //       );
    //     }
    //   } else {
    //     $rootScope.global.GLOBAL_EMBEDDED_EXPO = false;
    //   }
    // }

    $rootScope.global.showLoadingModal = showLoadingModal;
    $rootScope.global.hideLoadingModal = hideLoadingModal;
    $rootScope.global.showHtmlDialog = showHtmlDialog;

    function showHtmlDialog(title, html) {
      $mdDialog.show({
        controller: "ShowHtmlDialogController",
        controllerAs: "vm",
        templateUrl: "app/main/dialogs/showHtml-dialog/showhtml-dialog.html",
        parent: angular.element(document.body),
        targetEvent: null,
        scope: $rootScope,
        preserveScope: true,
        clickOutsideToClose: true,
        locals: {
          title: title,
          html: html
        }
      });
    }

    function hideLoadingModal() {
      $mdDialog.hide();
    }

    function showLoadingModal(ev) {
      $mdDialog.show({
        controller: "LoadingDialogController",
        controllerAs: "vm",
        templateUrl: "app/main/dialogs/loading-dialog/loading-dialog.html",
        parent: angular.element(document.body),
        targetEvent: ev,
        scope: $rootScope,
        preserveScope: true,
        escapeToClose: false,
        clickOutsideToClose: false,
        locals: {}
      });
    }

    $rootScope.ORDER_STATUSES = ORDER_STATUSES;
    // Activate loading indicator
    var stateChangeStartEvent = $rootScope.$on("$stateChangeStart", function() {
      $rootScope.currentBranchId = null;
      $rootScope.loadingProgress = true;
    });

    // De-activate loading indicator
    var stateChangeSuccessEvent = $rootScope.$on(
      "$stateChangeSuccess",
      function() {
        $timeout(function() {
          $rootScope.loadingProgress = false;
        });
      }
    );

    $rootScope.$on("$stateChangeError", function(
      event,
      toState,
      toParams,
      fromState,
      fromParams,
      error
    ) {
      if (error === "AUTH_REQUIRED") {
        $state.go("app.login");
      }
    });

    // Store state in the root scope for easy access
    $rootScope.state = $state;

    // Cleanup
    $rootScope.$on("$destroy", function() {
      stateChangeStartEvent();
      stateChangeSuccessEvent();
    });
  }
})();


try {
	console.log('%c HY ', 'background: #FF0000; color: #fff; font-size:64px;');
	console.log('%c hadiyemek.com ', 'background: #FF0000; color: #fff; font-size:24px;');
	console.log('%c 🍻😎', 'background: #FF0000; color: #fff; font-size:15px;');
	console.log('%c dev@hadiyemek.com', 'background: #FF0000; color: #fff; font-size:15px;');
} catch (e) {
}

(function() {
  "use strict";

  angular.module("angularhadiyemek").config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    $urlRouterProvider.otherwise("/");

    $stateProvider
      .state("app", {
        abstract: true,
        views: {
          "main@": {
            templateUrl: "app/layout.html",
            controller: "MainController as vm"
          },
          "toolbar@app": {
            templateUrl: "app/toolbar/toolbar.html",
            controller: "ToolbarController as vm"
          }
        }
      })
      .state("app.index", {
        url: "/",
        views: {
          "main@": {
            templateUrl: "app/core/layouts/content-only.html",
            controller: "MainController as vm"
          },
          "content@app.index": {
            template: '<div class="p-20 md-headline">Yükleniyor</div>',
            controller: function($state, $timeout) {
              console.log("// TODO: fb pixel tracks")
              $timeout(function() {
                $state.go("app.branchList.branchs");
              }, 300);
            }
          }
        },
        resolve: {
          currentAuth: function() {
            return firebaseHelper.requireSignIn(true);
          }
        }
      });
  }
})();

(function() {
  "use strict";

  angular
    .module("angularhadiyemek")
    .factory("sceStrategy", function($sce) {
      return function(value, mode) {
        if (mode === "text") {
          var result = "";
          result = $sce.trustAsHtml(value);
          if (result.$unwrapTrustedValue) {
            result = result.$unwrapTrustedValue();
          }
          value = result;
        }
        return value;
      };
    })
    .filter("momentDate", function() {
      return function(date) {
        if(!date){
          return "-";
        }else{
          return moment(date).format("DD/MM/YY HH:mm");
        }
      };
    })
    .filter("momentDateWithDayName", function() {
      return function(date) {
        if(!date){
          return "-";
        }else{
          return moment(date).format("DD/MM/YY dddd HH:mm");
        }
      };
    })
    .filter("momentDateWithDayNameWithDiff", function() {
			return function(date, diffMinutes) {
				if (!date) {
					return "-";
				} else {
					var diffText = "";
					if (diffMinutes) {
						var mom1 = moment(date);
						mom1.minutes(mom1.minutes() + diffMinutes);
						diffText = "-" + mom1.format("HH:mm");
					}
					var mom = moment(date);
					return mom.format("DD/MM/YY dddd HH:mm") + diffText;
				}
			};
		})
    .filter("priceText", function() {
      return function(priceText) {
        return formatTurkishLiraText(priceText);
      };
    })
    .filter("optionTextareaFix", function() {
      return function(text) {
        return text ? text.replace(/\n/g, "-") : text;
      };
    })
    .filter("filterByKeyName", function() {
      return filterByKeyNameFunction;
    })
    .filter("dateCalendar", function() {
      return function(value) {
        return moment(value).format("DD MMMM YYYY");
      };
    })
    .filter("dateHour", function() {
      return function(value) {
        return moment(value).format("HH:mm");
      };
    })
    .filter("filterOptionText", function() {
      return function(option) {
        var addition = "";
        if (option.AdditionalPrice < 0) {
          addition =
            " [-" +
            formatTurkishLiraText(Math.abs(option.AdditionalPrice)) +
            " TL]";
        } else if (option.AdditionalPrice > 0) {
          addition =
            " [+" + formatTurkishLiraText(option.AdditionalPrice) + " TL]";
        }
        return option.Name + addition;
      };
    })
    .directive("eatClickIf", [
      "$parse",
      "$rootScope",
      function($parse, $rootScope) {
        return {
          // this ensure eatClickIf be compiled before ngClick
          priority: 100,
          restrict: "A",
          compile: function($element, attr) {
            var fn = $parse(attr.eatClickIf);
            return {
              pre: function link(scope, element) {
                var eventName = "click";
                element.on(eventName, function(event) {
                  var callback = function() {
                    if (
                      fn(scope, {
                        $event: event
                      })
                    ) {
                      // prevents ng-click to be executed
                      event.stopImmediatePropagation();
                      // prevents href
                      event.preventDefault();
                      return false;
                    }
                  };
                  if ($rootScope.$$phase) {
                    scope.$evalAsync(callback);
                  } else {
                    scope.$apply(callback);
                  }
                });
              },
              post: function() {}
            };
          }
        };
      }
    ]);
})();

var filterByKeyNameFunction = function(object, search, keyName) {
  if (!object) return object;
  if (!keyName) return object;
  if (!search) return object;
  search = URLify(search);
  var result = {};
  for (var key in object) {
    var dis = object[key];
    if (dis[keyName]) {
      if (URLify(dis[keyName]).indexOf(search) !== -1) {
        result[key] = dis;
      }
    }
  }
  return result;
};

(function ()
{
    'use strict';

    angular
        .module('angularhadiyemek')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(angularhadiyemekTheming, $rootScope)
    {
        var vm = this;

        // Data
        vm.themes = angularhadiyemekTheming.themes;

        //////////
		vm.on_IsSalesRepresentative_valueChange = function () {
			$rootScope.isSalesRepresentative = salesRepresentativeHelpers.isSalesRepresentative;
		}
	}
})();

function on_IsSalesRepresentative_valueChange() {
	var bodyScope = angular.element(document.body).scope();
	if (bodyScope) {
		bodyScope.vm.on_IsSalesRepresentative_valueChange();
	}
}
(function ()
{
    'use strict';

    angular
        .module('angularhadiyemek');
})();

(function ()
{
    'use strict';

    angular
        .module('angularhadiyemek')
        .config(config);

    /** @ngInject */
    function config()
    {
        // Put your common app configurations here

    }

})();

(function() {
  "use strict";

  angular.module("angularhadiyemek").factory("apiStream", apiStreamService);

  /** @ngInject */
  function apiStreamService($q, $http) {
    var api = {};
    // api.samplePath = function(requestObject) {
    //   return api.request(CONSTANTS_STREAM_API.samplePath, requestObject);
    // };
    api.request = function(endPointUrl, requestObject) {
      var baseUrl = API_END_POINTS.STREAM_BASE;
      if (window.location.host.indexOf("localhost") !== -1) {
        baseUrl = API_END_POINTS.LOCAL_STREAM_BASE;
      }
      if (baseUrl[baseUrl.length - 1] !== "/") {
        baseUrl = baseUrl + "/";
      }
      return api.makeRequest(baseUrl, endPointUrl, requestObject);
    };
    api.requestWithoutUserToken = function(endPointUrl, requestObject) {
      var baseUrl = API_END_POINTS.BASE;
      if (window.location.host.indexOf("localhost") !== -1) {
        baseUrl = API_END_POINTS.LOCAL_BASE;
      }
      return api.makeRequestWithoutUserToken(
        baseUrl,
        endPointUrl,
        requestObject
      );
    };
    api.makeRequestWithoutUserToken = function(
      baseUrl,
      endPointUrl,
      requestObject
    ) {
      var deferred = $q.defer();
      requestObject.ref = window.top.location.host;
      var req = {
        method: "POST",
        url: baseUrl + endPointUrl,
        headers: {
          "Content-Type": "application/json"
        },
        data: requestObject
      };
      $http(req).then(
        function(resp) {
          deferred.resolve(resp);
        },
        function(err) {
          console.error(JSON.stringify(err, null, "\t"));
          deferred.reject(err);
        }
      );
      return deferred.promise;
    };
    api.makeRequest = function(baseUrl, endPointUrl, requestObject) {
      var deferred = $q.defer();
      requestObject.ref = window.top.location.host;
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(function(idToken) {
          if (idToken) {
            var req = {
              method: "POST",
              url: baseUrl + endPointUrl,
              headers: {
                Authorization: idToken,
                "Content-Type": "application/json"
              },
              data: requestObject
            };
            $http(req).then(
              function(resp) {
                deferred.resolve(resp);
              },
              function(err) {
                console.error(JSON.stringify(err, null, "\t"));
                deferred.reject(err);
              }
            );
          } else {
            deferred.reject({
              error: "idToken bulunamadı"
            });
          }
        });
      return deferred.promise;
    };
    return api;
  }
})();

(function() {
	'use strict';

	angular
		.module('angularhadiyemek')
		.factory('api', apiService);

	/** @ngInject */
	function apiService($q, $http) {
		var api = {};
		api.approveOrder = function(requestObject) {
			return api.request(CONSTANTS.APPROVE_ORDER, requestObject);
		};
		api.refuseOrder = function(requestObject) {
			return api.request(CONSTANTS.REFUSE_ORDER, requestObject);
		};
		api.checkWebAppSubdomain = function(requestObject) {
			return api.request(CONSTANTS.CHECK_WEB_APP_SUBDOMAIN, requestObject);
		};
		api.createBranch = function(requestObject) {
			return api.request(CONSTANTS.CREATE_BRANCH, requestObject);
		};
		api.getAdminUsers = function(requestObject) {
			return api.request(CONSTANTS.getAdminUsers, requestObject);
		};
		api.setAdminUser = function(requestObject) {
			return api.request(CONSTANTS.setAdminUser, requestObject);
		};
		api.changeOwner = function(requestObject) {
			return api.request(CONSTANTS.changeOwner, requestObject);
		};
		api.verifyEmailCode = function(requestObject) {
			if(firebase.auth().currentUser){
				return api.request(CONSTANTS.verifyEmailCode, requestObject);
			}else{
				return api.requestWithoutUserToken(CONSTANTS.verifyEmailCode, requestObject);
			}
		};
		api.retrievePaymentInfo = function(requestObject) {
			return api.request(CONSTANTS.RETRIEVE_PAYMENT_INFO, requestObject);
		};
		api.makePaymentNow = function(requestObject) {
			return api.request(CONSTANTS.makePaymentNow, requestObject);
		};
		api.setSubscriptionWithPacketId = function(requestObject) {
			return api.request(CONSTANTS.setSubscriptionWithPacketId, requestObject);
		};
		api.createBillingInfo = function(requestObject) {
			return api.request(CONSTANTS.CREATE_BILLING_INFO, requestObject);
		};
		api.sendMeOrderTrackingApps = function(requestObject) {
			return api.request(CONSTANTS.sendMeOrderTrackingApps, requestObject);
		};
		api.sendVerificationEmail = function(requestObject) {
			return api.request(CONSTANTS.sendVerificationEmail, requestObject);
		};
		api.sendMeVerificationCode = function(requestObject) {
			if(firebase.auth().currentUser){
				return api.request(CONSTANTS.SEND_ME_VERIFICATION_CODE, requestObject);
			}else{
				return api.requestWithoutUserToken(CONSTANTS.SEND_ME_VERIFICATION_CODE, requestObject);
			}
		};
		api.verifySmsCode = function(requestObject) {
			if(firebase.auth().currentUser){
				return api.request(CONSTANTS.VERIFY_SMS_CODE, requestObject);
			}else{
				return api.requestWithoutUserToken(CONSTANTS.VERIFY_SMS_CODE, requestObject);
			}
		};
		api.request = function(endPointUrl, requestObject) {
			var baseUrl = API_END_POINTS.BASE;
			if (window.location.host.indexOf("localhost") !== -1) {
				baseUrl = API_END_POINTS.LOCAL_BASE;
			}
			return api.makeRequest(baseUrl, endPointUrl, requestObject);
		};
		api.requestWithoutUserToken = function(endPointUrl, requestObject) {
			var baseUrl = API_END_POINTS.BASE;
			if (window.location.host.indexOf("localhost") !== -1) {
				baseUrl = API_END_POINTS.LOCAL_BASE;
			}
			return api.makeRequestWithoutUserToken(baseUrl, endPointUrl, requestObject);
		};
		api.makeRequestWithoutUserToken = function(baseUrl, endPointUrl, requestObject) {
			var deferred = $q.defer();
			requestObject.ref = window.top.location.host;
			var req = {
				method: 'POST',
				url: baseUrl + endPointUrl,
				headers: {
					'Content-Type': "application/json"
				},
				data: requestObject
			};
			$http(req).then(function(resp) {
				deferred.resolve(resp);
			}, function(err) {
				console.error(JSON.stringify(err, null, "\t"));
				deferred.reject(err);
			});
			return deferred.promise;
		};
		api.makeRequest = function(baseUrl, endPointUrl, requestObject) {
			var deferred = $q.defer();
			requestObject.ref = window.top.location.host;
			firebase.auth().currentUser.getIdToken()
				.then(function(idToken) {
					if (idToken) {
						var req = {
							method: 'POST',
							url: baseUrl + endPointUrl,
							headers: {
								'Authorization': idToken,
								'Content-Type': "application/json"
							},
							data: requestObject
						};
						$http(req).then(function(resp) {
							deferred.resolve(resp);
						}, function(err) {
							console.error(JSON.stringify(err, null, "\t"));
							deferred.reject(err);
						});
					} else {
						deferred.reject({
							'error': "idToken bulunamadı"
						});
					}
				});
			return deferred.promise;
		};
		return api;
	}

})();

(function() {
  "use strict";

  angular.module("angularhadiyemek").factory("apiAdmin", apiAdminService);

  /** @ngInject */
  function apiAdminService($q, $http) {
    var api = {};
    api.setStatusOnWay = function(requestObject) {
      return api.request(CONSTANTS_ADMIN_API.SET_STATUS_ON_WAY, requestObject);
    };
    api.getOrderStatusIpAddresses = function(requestObject) {
      return api.request(CONSTANTS_ADMIN_API.getOrderStatusIpAddresses, requestObject);
    };
    api.setStatusDone = function(requestObject) {
      return api.request(CONSTANTS_ADMIN_API.SET_STATUS_DONE, requestObject);
    };
    api.getBranchNotifications = function(requestObject) {
      return api.request(CONSTANTS_ADMIN_API.GET_BRANCH_NOTIFICATIONS, requestObject);
    };
    api.addBranchNotifications = function(requestObject) {
      return api.request(CONSTANTS_ADMIN_API.ADD_BRANCH_NOTIFICATIONS, requestObject);
    };
    api.subscribeToBranch = function(requestObject) {
      return api.request(CONSTANTS_ADMIN_API.SUBSCRIBE_TO_BRANCH, requestObject);
    };
    api.unsubscribeToBranch = function(requestObject) {
      return api.request(CONSTANTS_ADMIN_API.UNSUBSCRIBE_TO_BRANCH, requestObject);
    };
    api.getAllBranchSubscriptions = function(requestObject) {
      return api.request(CONSTANTS_ADMIN_API.GET_ALL_BRANCH_SUBSCRIPTIONS, requestObject);
    };
    api.addBranchPrimaryNotifications = function(requestObject) {
      return api.request(CONSTANTS_ADMIN_API.ADD_BRANCH_PRIMARY_NOTIFICATIONS, requestObject);
    };
    api.deleteBranchNotifications = function(requestObject) {
      return api.request(CONSTANTS_ADMIN_API.DELETE_BRANCH_NOTIFICATIONS, requestObject);
    };
    api.createTestOrder = function(requestObject) {
      return api.request(CONSTANTS_ADMIN_API.CREATE_TEST_ORDER, requestObject);
    };
    api.request = function(endPointUrl, requestObject) {
      var baseUrl = API_END_POINTS.ADMIN_BASE;
      if (window.location.host.indexOf("localhost") !== -1) {
        baseUrl = API_END_POINTS.LOCAL_ADMIN_BASE;
      }
      if (baseUrl[baseUrl.length - 1] !== "/") {
        baseUrl = baseUrl + "/";
      }
      return api.makeRequest(baseUrl, endPointUrl, requestObject);
    };
    api.requestWithoutUserToken = function(endPointUrl, requestObject) {
      var baseUrl = API_END_POINTS.BASE;
      if (window.location.host.indexOf("localhost") !== -1) {
        baseUrl = API_END_POINTS.LOCAL_BASE;
      }
      return api.makeRequestWithoutUserToken(
        baseUrl,
        endPointUrl,
        requestObject
      );
    };
    api.makeRequestWithoutUserToken = function(
      baseUrl,
      endPointUrl,
      requestObject
    ) {
      var deferred = $q.defer();
      requestObject.ref = window.top.location.host;
      var req = {
        method: "POST",
        url: baseUrl + endPointUrl,
        headers: {
          "Content-Type": "application/json"
        },
        data: requestObject
      };
      $http(req).then(
        function(resp) {
          deferred.resolve(resp);
        },
        function(err) {
          console.error(JSON.stringify(err, null, "\t"));
          deferred.reject(err);
        }
      );
      return deferred.promise;
    };
    api.makeRequest = function(baseUrl, endPointUrl, requestObject) {
      var deferred = $q.defer();
      requestObject.ref = window.top.location.host;
      firebase
        .auth()
        .currentUser.getIdToken()
        .then(function(idToken) {
          if (idToken) {
            var req = {
              method: "POST",
              url: baseUrl + endPointUrl,
              headers: {
                Authorization: idToken,
                "Content-Type": "application/json"
              },
              data: requestObject
            };
            $http(req).then(
              function(resp) {
                deferred.resolve(resp);
              },
              function(err) {
                console.error(JSON.stringify(err, null, "\t"));
                deferred.reject(err);
              }
            );
          } else {
            deferred.reject({
              error: "idToken bulunamadı"
            });
          }
        });
      return deferred.promise;
    };
    return api;
  }
})();


var API_END_POINTS = {

	"GOOGLE_CLOUD_BASE": "https://europe-west1-hadiyemekcom.cloudfunctions.net/",
	"GOOGLE_CLOUD_LOCAL_BASE": "http://localhost-lcaol-hs-api-test.com:5000/hadiyemekcom/us-central1/",

  "BASE": "https://cxgs2kp4la.execute-api.eu-central-1.amazonaws.com/prod/",
  "ADMIN_BASE": "https://lqdql0ndx8.execute-api.eu-central-1.amazonaws.com/prod/",
  "STREAM_BASE": "https://tg2jjxnkyl.execute-api.eu-central-1.amazonaws.com/prod/",

	"LOCAL_BASE": "http://localhost:3131/",
  "LOCAL_ADMIN_BASE": "http://localhost:3141/",
  "LOCAL_STREAM_BASE": "http://localhost:3151/",
  "LOCAL_PROMOTION_BASE": "http://localhost:3231/",

};

///////////////////////////////////KEYS////////////////////////////
var IS_ONLINE_KEY = "IS_ONLINE_KEY";
///////////////////////////////////KEYS////////////////////////////
var CONSTANTS_STREAM_API = {
	samplePath: "samplePath",
};
var CONSTANTS_ADMIN_API = {
	SET_STATUS_ON_WAY: "setStatusOnWay",
	getOrderStatusIpAddresses: "getOrderStatusIpAddresses",
	SET_STATUS_DONE: "setStatusDone",
	GET_BRANCH_NOTIFICATIONS: "getBranchNotifications",
	DELETE_BRANCH_NOTIFICATIONS: "deleteBranchNotifications",
	ADD_BRANCH_NOTIFICATIONS: "addBranchNotifications",
	ADD_BRANCH_PRIMARY_NOTIFICATIONS: "addBranchPrimaryNotifications",
	SUBSCRIBE_TO_BRANCH: "subscribeToBranch",
	UNSUBSCRIBE_TO_BRANCH: "unsubscribeToBranch",
	CREATE_TEST_ORDER: "createTestOrder",
	GET_ALL_BRANCH_SUBSCRIPTIONS: "getAllBranchSubscriptions",
};

var CONSTANTS = {
	APPROVE_ORDER: "approveOrder",
	REFUSE_ORDER: "refuseOrder",
	SEND_ME_VERIFICATION_CODE: "sendMeVerificationCode",
	VERIFY_SMS_CODE: "verifySmsCode",
	CHECK_WEB_APP_SUBDOMAIN: "checkWebAppSubdomain",
	CREATE_BRANCH: "createBranch",
	CREATE_BILLING_INFO: "createBillingInfo",
	sendMeOrderTrackingApps: "sendMeOrderTrackingApps",
	sendVerificationEmail: "sendVerificationEmail",
	verifyEmailCode: "verifyEmailCode",
	RETRIEVE_PAYMENT_INFO: "retrievePaymentInfo",
	setSubscriptionWithPacketId: "setSubscriptionWithPacketId",
	getAdminUsers: "getAdminUsers",
	setAdminUser: "setAdminUser",
	changeOwner: "changeOwner",
	makePaymentNow: "makePaymentNow",
};

var CONSTANTS_SalesRepresentative_STATUSES = {
	APPLICATION: 'APPLICATION',
	APPROVED: 'APPROVED',
	REJECTED: 'REJECTED',
};

var BRANCH_CONSTANTS = {
	MASTER_STATUS: {
		CLOSED: -1,
		OPEN: 1
	},
	STATUS: {
		OPEN: 1,
		CLOSED: -1,
		BUSY: -2
	}
};

var ORDER_STATUSES = {
	NEW: { text: "Yeni Sipariş", code: "NEW" },
	PREP: { text: "Hazırlanıyor", code: "PREP" },
	ONWAY: { text: "Yolda", code: "ONWAY" },
	DONE: { text: "Tamamlandı", code: "DONE" },
	REFUSED: { text: "Reddedildi", code: "REFUSED" },
	CANCELLED: { text: "iptal edildi", code: "CANCELLED" },
	ARCHIVED: { text: "Arşivlendi", code: "ARCHIVED" },
};

var ORDER_REJECT_REASONS = {
	OUT_OF_STOCK: {
		text: "Ürün yok",
		code: "OUT_OF_STOCK"
	},
	DELAY_WITH_CUSTOMER_CANCEL: {
		text: "Gecikmeden dolayı müşteri iptali",
		code: "DELAY_WITH_CUSTOMER_CANCEL"
	},
	BUSY: {
		text: "Yoğunluk",
		code: "BUSY"
	},
	WEATHER_PROBLEMS: {
		text: "Kötü hava koşulları",
		code: "WEATHER_PROBLEMS"
	},
	SHIPPING_PROBLEMS: {
		text: "Motorcu / Motor problemleri",
		code: "SHIPPING_PROBLEMS"
	},
	NON_DELIVERY_AREA: {
		text: "Gönderim bölgesi dışı",
		code: "NON_DELIVERY_AREA"
	},
	OTHER: {
		text: "Diğer",
		code: "OTHER"
	}
};

var authErrors = {
	"auth/user-not-found": "Böyle bir kullanıcı bulunamadı.",
	"auth/frequently-login": "Biraz bekledikten sonra tekrar deneyiniz",
	"auth/too-many-requests": "Biraz bekledikten sonra tekrar deneyiniz",
	"auth/requires-recent-login": "Bu işlemi yapmak için çıkış yapıp tekrar giriş yapmanız gerekmektedir.",
	"auth/wrong-password": "Yanlış şifre ya da kullanıcı",
	"auth/user-disabled": "Bu kullanıcı için hesap kapalı",
	"auth/unauthorized-domain": "Bu site için sosyal giriş işlemleri henüz aktif hale getirilmedi. Lütfen hazirsiparis.com ile iletişime geçin.",
	"auth/provider-already-linked": "Zaten daha önce hesabınız bağlanmış",
	"auth/argument-error": "Hatalı giriş. Lütfen bilgilerinizi kontrol edip tekrar deneyiniz",
	"auth/mobileNumberIsNotValid": "Lütfen cep telefonu numaranızı kontrol edin. Numaranız 5 ile başlamalı ve 10 adet rakamdan oluşmalıdır. Örnek: 5413332211",
	"auth/email-already-in-use": "Bu email ile daha önce üye olunmuş. Lütfen giriş yapın!",
	"auth/invalid-email": "Email yanlış",
	"auth/operation-not-allowed": "Bu işleme izniniz yok",
	"auth/weak-password": "Şifre güvenli değil, lütfen daha güvenli bir şifre seçiniz",
	"auth/credential-already-in-use": "Daha önce kayıt edilmiş. Giriş yapmalısınız.",
};

angular.module("angularhadiyemek").run(["$templateCache", function($templateCache) {$templateCache.put("app/layout.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div \nclass=\"appDataPublicName text-truncate\"><a ng-href=\"http://{{appDataPublic.hostname}}\" target=\"_blank\" \nclass=\"text-truncate\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"s24 icon\"></md-icon>{{appDataPublic.name}}</a>\n</div><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"text-truncate progress-text\" hide-xs>Kurulum: % {{percentageProgress}}<md-progress-linear class=\"md-accent\" \nmd-mode=\"determinate\" value=\"{{percentageProgress}}\"></md-progress-linear></div><div class=\"toolbar-separator\"></div>\n<md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!loadingProgress\" class=\"md-accent\" md-diameter=\"32\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"></div><span class=\"username\" hide show-gt-sm>{{firebaseUser.displayName}}\n</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content \nwidth=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account-key\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.passwordUpdate()\">Şifre ekle/değiştir</md-button></md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.logout()\">Çıkış</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/toolbar/toolbarWithLogo.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-printer\" class=\"icon s32\" hide-xs></md-icon><a \nui-sref=\"app.index\" class=\"logo-text\">Otomatik Yazdırma Ayarları</a></div><div class=\"toolbar-separator\"></div></div>\n<div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\" \nng-hide=\"isAutocallLead\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdMenu.open()\" aria-label=\"User settings\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div><span \nclass=\"username\" hide show-gt-sm>{{firebaseUser.displayName}}</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><span style=\"padding: 10px\" \nclass=\"username\">{{firebaseUser.displayName}}</span><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Çıkış</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"angularhadiyemek-theme-options\" \nclass=\"md-sidenav-right\"><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\">\n<div class=\"option-title\">Layout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap \nng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\"><md-radio-button \nng-repeat=\"layoutStyle in vm.layoutStyles\" ng-value=\"layoutStyle.value\"><div layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> <span class=\"text-center font-size-12 mt-8\">\n{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div><md-divider></md-divider><div \nclass=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/branchList/branchList.html","<div class=\"brachList-container\"><h3 ng-hide=\"vm.isLoading\">\nOtomatik Yazdırma seçeneklerini ayarlamak istediğiniz işletmeye tıklayın</h3><div ng-show=\"vm.isLoading\">\n<md-progress-circular class=\"md-warn\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></div><div \nng-show=\"!vm.isLoading && vm.branchLen === 0\">Siz henüz hiçbir işletmenin yöneticisi değilsiniz<br><br>\nBir işletmenin yöneticisi olmak için admin kullanıcınızın kurulumdaki yöneticiler kısmından sizi davet etmesi gerekir. \n<span>kurulum.hadiyemek.com</span></div><div ng-hide=\"vm.isLoading\" layout=\"row\" \nng-repeat=\"(branchKey, branch) in vm.branchs\"><a class=\"md-button md-raised md-accent\" \nng-click=\"vm.openBranchOrdersWindow(branch, branchKey)\"><i class=\"icon s24 icon-store md-accent-bg\"></i>\n {{branch.appName}} - {{branch.name}} <i ng-show=\"vm.branchSettingsBranchsObj[branchKey].enabled\" \nclass=\"icon s32 icon-checkbox-marked-circle md-accent-bg\"></i> </a><a class=\"md-button md-raised md-primary\" \nng-click=\"vm.openBranchAutoPrintSettingsDialog(branch)\"><i class=\"icon s24 icon-cog md-primary-bg\"></i> Ayarlar <i \nng-show=\"vm.branchSettingsBranchsObj[branchKey].enabled\" class=\"icon s32 icon-checkbox-marked-circle md-primary-bg\">\n</i></a></div></div>");
$templateCache.put("app/main/branchList/footer-warns.html","<div ng-hide=\"vm.isLoading\"><br><h3>Menü ayarlar, çalışma saatleri, gönderim bölgeleri, ödeme tipleri <a \nng-show=\"!global.GLOBAL_EMBEDDED_EXPO\" class=\"md-button md-raised md-accent\" target=\"_blank\" \nhref=\"https://menutakip.hadiyemek.com/\">menutakip.hadiyemek.com </a><a href=\"#\" ng-show=\"global.GLOBAL_EMBEDDED_EXPO\">\nmenutakip.hadiyemek.com </a>Adresinden yapılmaktadır.</h3><div hide-gt-xs><br><md-divider></md-divider><br>\nBilgiyarınızdan sipariş bildirimlerini anında almak için <a href=\"#\">siparistakip.hadiyemek.com</a>\n adresini tarayıcınızda açın!<br></div><br><md-divider></md-divider><br><div ng-show=\"!global.GLOBAL_EMBEDDED_EXPO\"><a \nhref=\"https://kurulum.hadiyemek.com/mobil-siparis-takip.html\" target=\"_blank\">\nTelefonunuza uygun sipariş bildirim uygulamasını indirin</a></div><br><br><br><br><br></div>");
$templateCache.put("app/main/branchOrderDetails/approve-refuse-action-buttons.html","<div layout=\"row\" ng-hide=\"vm.order.currentStatus !== ORDER_STATUSES.NEW.code || vm.isApproveOrRefuseProcessing\" \nlayout-align=\"center center\" class=\"action-btns-container\"><md-button aria-label=\"ONAYLA\" ng-click=\"vm.approveOrder()\" \nclass=\"action-btn md-raised md-accent green animated flash\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\">\n</md-icon>ONAYLA</md-button><md-button aria-label=\"REDDET\" ng-click=\"vm.refuseOrder()\" \nclass=\"action-btn md-raised md-accent red\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon>REDDET</md-button></div>");
$templateCache.put("app/main/branchOrderDetails/branchOrderDetails.html","<div class=\"branchOrderDetails-container\"><div ng-show=\"vm.order.isTestOrder\"><div ng-if=\"!vm.isValidOwnerLoading\" \nng-include=\"\'app/main/branchOrderDetails/test-order.html\'\"></div></div><div ng-hide=\"vm.order.isTestOrder\"><div \nng-show=\"vm.isLoading\"><md-progress-circular class=\"md-warn\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular></div><div ng-hide=\"vm.isLoading\"><div \nng-include=\"\'app/main/branchOrderDetails/top-buttons.html\'\"></div><div class=\"action-btns-container-top\" \nng-include=\"\'app/main/branchOrderDetails/approve-refuse-action-buttons.html\'\"></div><div><h3>\nSipariş Numarası: {{vm.order.orderNumber}}</h3><div ng-include=\"\'app/main/branchOrderDetails/customer-info.html\'\">\n</div><div ng-include=\"\'app/main/branchOrderDetails/order-info.html\'\"></div><div \nng-include=\"\'app/main/branchOrderDetails/products.html\'\"></div><div \nng-include=\"\'app/main/branchOrderDetails/status-logs.html\'\"></div></div><div class=\"action-btns-container-bottom\" \nng-include=\"\'app/main/branchOrderDetails/approve-refuse-action-buttons.html\'\"></div></div></div></div>");
$templateCache.put("app/main/branchOrderDetails/customer-info.html","<div class=\"customer-details\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\" class=\"header\">\n{{vm.order.isCollection?\'GEL-AL Bilgileri\':\'Paket Sipariş Bilgileri\'}}</div><div class=\"body\"><div \nng-show=\"vm.order.customerOrderCount && vm.order.customerOrderCount > 0\" layout=\"row\" class=\"row\"><div class=\"title\">\nMüşterinin sipariş sayısı:</div><div>{{vm.order.customerOrderCount}}</div></div><div layout=\"row\" class=\"row\"><div \nclass=\"title\">Ad Soyad:</div><div>{{vm.order.address.name}}</div></div><div layout=\"row\" class=\"row\"><div \nclass=\"title\">Telefon:</div><div><a href=\"tel:0{{vm.order.address.mobilePhone}}\">0{{vm.order.address.mobilePhone}}</a>\n</div></div><div layout=\"row\" \nng-show=\"vm.order.address.hadiyemekDistrictName && vm.order.address.hadiyemekDistrictName !== \'\'\" class=\"row\"><div \nclass=\"title\">Semt:</div><div>{{vm.order.address.hadiyemekDistrictName}}</div></div><div \nng-show=\"!vm.order.isCollection\"><div layout=\"row\" class=\"row\"><div class=\"title\">Adres:</div><div>\n{{vm.order.address.address}}</div></div><div layout=\"row\" \nng-show=\"vm.order.address.addressDescription && vm.order.address.addressDescription !== \'\'\" class=\"row\"><div \nclass=\"title\">Tarif:</div><div>{{vm.order.address.addressDescription}}</div></div><div layout=\"row\" \nng-show=\"vm.order.address.company && vm.order.address.company !== \'\'\" class=\"row\"><div class=\"title\">Şirket:</div><div>\n{{vm.order.address.company}}</div></div></div></div></div>");
$templateCache.put("app/main/branchOrderDetails/order-info.html","<div class=\"order-details\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\" class=\"header\">\nSipariş bilgileri</div><div class=\"body\"><div layout=\"row\" ng-show=\"vm.order.isScheduled\" class=\"row\"><div \nclass=\"title\">Tarih:</div><div>\n{{vm.order.scheduledDate | momentDateWithDayNameWithDiff:(vm.order.isCollection?vm.order.collectionTime:vm.order.deliveryTime)}} (İleri tarihli)\n</div></div><div layout=\"row\" class=\"row\"><div class=\"title\">Tarih:</div><div>\n{{vm.order.createdAt | momentDateWithDayName}}</div></div><div layout=\"row\" class=\"row\"><div class=\"title\">Ödeme Tipi:\n</div><div>{{vm.order.paymentTypeTitle}}</div></div><div layout=\"row\" class=\"row pulse\"><div class=\"title\">\nMüşteri notu:</div><div>{{vm.order.customerNote}}</div></div></div></div>");
$templateCache.put("app/main/branchOrderDetails/print-menu.html","<md-menu md-position-mode=\"left bottom\"><md-button class=\"md-raised md-accent blue\" ng-click=\"$mdMenu.open()\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon>Yazdır <i class=\"icon s24 icon-chevron-down\"></i></md-button><md-menu-content>\n<md-menu-item class=\"md-indent\"><md-button ng-click=\"vm.print(\'A4Paper\', \'small_font\');\" class=\"md-accent\">A-4\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-button \nng-click=\"vm.print(\'A5Paper\', \'small_font\');\" class=\"md-accent\">A-5</md-button></md-menu-item><md-menu-divider>\n</md-menu-divider><md-menu-item class=\"md-indent\"><md-button ng-click=\"vm.print(\'Adisyon\', \'small_font\');\" \nclass=\"md-accent\">Adisyon</md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/main/branchOrderDetails/products.html","<div class=\"products-table\" layout=\"column\"><div layout=\"row\" layout-align=\"center center\" class=\"header\"><div \nflex=\"10\" class=\"text-center quantity\"><span hide-xs>Adet</span></div><div flex=\"60\" class=\"text-center\">Ürün</div><div\n flex=\"10\" hide-xs class=\"text-center\">Birm. Fyt.</div><div flex=\"20\" flex-xs=\"30\" class=\"text-center\">Toplam</div>\n</div><div layout=\"row\" layout-align=\"center center\" class=\"price-row\" ng-repeat=\"item in vm.order.visibleBucket\"><div \nclass=\"text-center quantity\" flex=\"10\">{{item.quantity}}</div><div class=\"details\" flex=\"60\">{{item.title}}<div \nclass=\"summarizedOptionsContainer\" ng-if=\"item.optionTextResult\" flex><pre>{{item.optionTextResult}}</pre></div></div>\n<div flex=\"10\" hide-xs ng-if=\"!vm.order.isCollection\" class=\"text-center unit-price\">{{item.unitPrice | priceText}} TL\n</div><div flex=\"10\" hide-xs ng-if=\"vm.order.isCollection\" class=\"text-center unit-price\">\n{{item.unitCollectionPrice | priceText}} TL</div><div flex=\"20\" flex-xs=\"30\" class=\"text-center\">\n{{ item.total | priceText}} TL</div></div><div ng-include=\"\'app/main/branchOrderDetails/total-details.html\'\"></div>\n</div>");
$templateCache.put("app/main/branchOrderDetails/status-logs.html","<div class=\"status-logs\" ng-hide=\"vm.order.currentStatus === ORDER_STATUSES.NEW.code\"><span ng-show=\"vm.yourIpAddress\">\nip\'niz: <b>{{vm.yourIpAddress}}</b></span><md-button ng-hide=\"vm.isGetOrderStatusIpAddressBtnHidden\" \nng-click=\"vm.getOrderStatusIpAddress()\">ip\'leri göster</md-button><table class=\"light-text\"><tr \nng-repeat=\"log in vm.order.statusLogs\"><td>{{log.date | momentDateWithDayName}}</td><td>{{log.text}}</td><td>\n{{log.reason}}</td><td>Kullanıcı id\'si: {{log.userId}}</td><td><b>{{log.ipAddress}}</b>\n {{ (vm.yourIpAddress === log.ipAddress)?\"(Siz)\":\"\" }}</td></tr></table></div>");
$templateCache.put("app/main/branchOrderDetails/test-order.html","<h2>Bu bir deneme siparişidir</h2><h3>Yazdırma seçenekleri deneme siparişlerinde kapalıdır</h3><h3>\nLütfen onaylayıp pencereyi kapatın</h3><div class=\"action-btns-container-top\" \nng-include=\"\'app/main/branchOrderDetails/approve-refuse-action-buttons.html\'\"></div><br><br><br><br>");
$templateCache.put("app/main/branchOrderDetails/top-buttons.html","<div layout=\"row\" layout-align=\"end center\" class=\"top-btns-container\"><div ng-hide=\"vm.order.isTestOrder\" \nng-include=\"\'app/main/branchOrderDetails/print-menu.html\'\"></div></div>");
$templateCache.put("app/main/branchOrderDetails/total-details.html","<div layout=\"column\" class=\"total-container\" layout-align=\"end end\"><div class=\"h4\" ng-if=\"vm.isSubTotalVisible()\">\nAra Toplam: {{ vm.getSubTotal() | priceText}}TL</div><div class=\"h4 text-italic\" ng-if=\"vm.order.isJokerAvailable\">\nCan kurtaran indirim kullanıldı -{{ vm.order.campaigns.joker.discount | priceText}}TL</div><div class=\"h4 text-italic\" \nng-if=\"vm.order.isInvitationDiscountAvailable\">\nArkadaş daveti hediyesi -{{vm.order.campaigns.inviteFriends.invitedDiscount | priceText}}TL</div><div \nclass=\"h4 text-italic\" ng-if=\"vm.order.isBuyOneGetOneFreeAvailable\">\nBir alana diğer %{{vm.order.campaigns.buyOneGetOneFreeCampaign.discountPercentage}} indirimli -{{vm.order.campaigns.buyOneGetOneFreeCampaign.discount | priceText}}TL\n</div><div class=\"h4 text-italic\" ng-if=\"vm.order.giveDiscountFirstNthOrdersDetails\">\nİlk {{ vm.order.campaigns.giveDiscountFirstNthOrders.orderLimit> 1 ? vm.order.campaigns.giveDiscountFirstNthOrders.orderLimit : \'\' }} siparişe indirim -{{vm.order.campaigns.giveDiscountFirstNthOrders.discount | priceText}}TL\n</div><div class=\"h4 text-italic\" ng-if=\"vm.order.percentageDiscountForBucket\">\nSepetinize %{{vm.order.campaigns.percentageDiscountForBucket.percent}} indirim -{{vm.order.campaigns.percentageDiscountForBucket.calculatedPercentDiscount | priceText}}TL\n</div><div class=\"h4 text-italic\" ng-if=\"vm.order.isUserUsedCredit\">\nParaPuan kullanıldı -{{ vm.order.usedCreditsBalance | priceText}}TL</div><div class=\"h4 text-italic\" \nng-if=\"vm.order.deliveryFee\">Teslimat ücreti: +{{vm.order.deliveryFee | priceText}}TL</div><div class=\"h4 text-italic\" \nng-if=\"vm.order.serviceFee && vm.order.serviceFee > 0\">Servis ücreti: +{{vm.order.serviceFee | priceText}}TL</div><div \nclass=\"h2\"><strong>Toplam: </strong><span class=\"total-val\">{{vm.order.total | priceText}} TL</span></div></div>");
$templateCache.put("app/main/branchOrders/action-buttons.html","<md-button aria-label=\"Hazırlanıyor\" ng-disabled=\"true\" \nng-class=\"{\'current\': order.currentStatus === ORDER_STATUSES.PREP.code}\" class=\"md-raised md-icon-button orange-icon\">\n<md-icon md-font-icon=\"icon-timer\"></md-icon></md-button><md-button aria-label=\"Yolda\" \nng-click=\"vm.setStatusOnWay(order)\" ng-disabled=\"order.currentStatus !== ORDER_STATUSES.PREP.code\" \nng-class=\"{\'current\': order.currentStatus === ORDER_STATUSES.ONWAY.code}\" class=\"md-raised md-icon-button blue-icon\">\n<md-icon md-font-icon=\"icon-bike\"></md-icon></md-button><md-button aria-label=\"TAMAMLA\" \nng-click=\"vm.setStatusDone(order)\" ng-disabled=\"order.currentStatus !== ORDER_STATUSES.ONWAY.code\" \nclass=\"md-raised md-icon-button green-icon\"><md-icon md-font-icon=\"icon-silverware-variant\"></md-icon></md-button>\n<md-button aria-label=\"REDDET\" ng-click=\"vm.refuseOrder(order)\" class=\"md-raised md-icon-button red-icon\"><md-icon \nmd-font-icon=\"icon-close-circle\"></md-icon><md-tooltip>REDDET</md-tooltip></md-button><md-button aria-label=\"YAZDIR\" \nng-show=\"!order.isTestOrder\" ng-click=\"vm.printViaDefaultPrinter(order)\" class=\"md-raised md-icon-button md-accent\">\n<md-icon md-font-icon=\"icon-printer\"></md-icon></md-button>");
$templateCache.put("app/main/branchOrders/branchOrders.html","<div class=\"brachOrders-container\"><div ng-show=\"vm.isLoading\"><md-progress-circular class=\"md-warn\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></div><div><i class=\"icon s24 icon-store\"></i>\n {{vm.smallBranchObj.appName}} - {{vm.smallBranchObj.name}}</div><div class=\"simple-table-container\" \nng-hide=\"vm.isLoading\" ng-if=\"(vm.orders.length + vm.currentOrders.length) > 0\"><h1>İşlemdeki Siparişler</h1><div \nng-include=\"\'app/main/branchOrders/new-orders.html\'\"></div><div \nng-include=\"\'app/main/branchOrders/current-orders.html\'\"></div></div><div class=\"simple-table-container\" \nng-hide=\"vm.isLoading\" ng-if=\"!(vm.orders.length + vm.currentOrders.length) > 0\"><h1>İşlemdeki Siparişler</h1><div>\nYeni siparişler burada görünür. Şu anda 0 yeni siparişiniz var.</div></div><md-divider ng-hide=\"isAutocallLead\">\n</md-divider><div class=\"simple-table-container finished-orders\" ng-hide=\"vm.isLoading\" \nng-if=\"vm.finishedOrders.length > 0\"><h1>Tamamlanmış Siparişler</h1><div \nng-include=\"\'app/main/branchOrders/finished-orders.html\'\"></div></div><div \nclass=\"simple-table-container finished-orders\" ng-hide=\"vm.isLoading || isAutocallLead\" \nng-if=\"!(vm.finishedOrders.length > 0)\"><h1>Tamamlanmış Siparişler</h1><div>\n1 günden daha önce verilmiş siparişler arşivlenir</div></div><br><br><br><md-divider ng-hide=\"isAutocallLead\">\n</md-divider><br></div>");
$templateCache.put("app/main/branchOrders/current-orders.html","<table class=\"simple\" ng-repeat=\"order in vm.currentOrders\" ms-responsive-table><thead \nng-click=\"vm.openOrderDetail(order);\"><tr><th>Sipariş<br>Num</th><th>Ad</th><th>Adres</th><th>Ödeme</th><th>Toplam</th>\n<th>Tarih</th><th hide-xs hide-sm>Onay Zamanı</th><th hide-xs hide-sm>Durum</th><th hide-xs hide-sm \nclass=\"text-center\">Aksiyonlar</th></tr></thead><tbody><tr><td ng-click=\"vm.openOrderDetail(order);\">\n{{order.orderNumber}}</td><td ng-click=\"vm.openOrderDetail(order);\">{{order.address.name}}</td><td \nng-hide=\"order.isCollection\" ng-click=\"vm.openOrderDetail(order);\">\n{{order.isTestOrder?\'Deneme siparişi\':order.address.address}}</td><td ng-show=\"order.isCollection\" \nng-click=\"vm.openOrderDetail(order);\">GEL-AL</td><td ng-click=\"vm.openOrderDetail(order);\">{{order.paymentTypeTitle}}\n</td><td ng-click=\"vm.openOrderDetail(order);\">{{order.total | priceText}}</td><td \nng-click=\"vm.openOrderDetail(order);\">{{order.createdAt | momentDate}}</td><td hide-xs hide-sm \nng-click=\"vm.openOrderDetail(order);\">{{order.approveDate | momentDate}}</td><td hide-xs hide-sm \nng-click=\"vm.openOrderDetail(order);\">{{order.currentStatusText}}</td><td hide-xs hide-sm \nclass=\"text-center action-cell\"><div ng-include=\"\'app/main/branchOrders/action-buttons.html\'\"></div></td></tr><tr \nclass=\"row-end\"><td colspan=\"10\" hide-gt-sm class=\"action-cell\"><div \nng-include=\"\'app/main/branchOrders/action-buttons.html\'\"></div></td></tr></tbody></table>");
$templateCache.put("app/main/branchOrders/finished-orders.html","<table class=\"simple\" ms-responsive-table><thead><tr><th>Sipariş<br>Num</th><th>Ad</th><th>Adres</th><th>Ödeme</th><th>\nToplam</th><th>Tarih</th><th hide-xs hide-sm>Onay Zamanı</th><th hide-xs hide-sm>Durum</th></tr></thead><tbody \nng-repeat=\"order in vm.finishedOrders\"><tr ng-click=\"vm.openOrderDetail(order);\"><td>{{order.orderNumber}}</td><td>\n{{order.address.name}}</td><td ng-hide=\"order.isCollection\">\n{{order.isTestOrder?\'Deneme siparişi\':order.address.address}}</td><td ng-show=\"order.isCollection\">GEL-AL</td><td>\n{{order.paymentTypeTitle}}</td><td>{{order.total | priceText}}</td><td>{{order.createdAt | momentDate}}</td><td \nhide-xs hide-sm>{{order.approveDate | momentDate}}</td><td hide-xs hide-sm>{{order.currentStatusText}}</td></tr>\n</tbody></table>");
$templateCache.put("app/main/branchOrders/new-orders.html","<div ng-repeat=\"order in vm.orders\"><table class=\"simple\" ms-responsive-table><thead><tr><th>Sipariş<br>Num</th><th>Ad\n</th><th>Adres</th><th>Ödeme</th><th>Toplam</th><th>Tarih</th><th hide-xs hide-sm>Onay Zamanı</th><th hide-xs hide-sm>\nDurum</th><th hide-xs hide-sm class=\"text-center\">Aksiyonlar</th></tr></thead><tbody><tr><td hide-xs>\n{{order.orderNumber}}</td><td>{{order.address.name}}</td><td ng-hide=\"order.isCollection\">\n{{order.isTestOrder?\'Deneme siparişi\':order.address.address}}</td><td ng-show=\"order.isCollection\">GEL-AL</td><td>\n{{order.paymentTypeTitle}}</td><td>{{order.total | priceText}}</td><td>{{order.createdAt | momentDate}}</td><td \nhide-xs hide-sm>-</td><td hide-xs hide-sm>{{order.currentStatusText}}</td><td hide-xs hide-sm \nclass=\"text-center action-cell\"><div layout-align=\"center center\" ng-hide=\"vm.isApproveOrRefuseProcessing\"><md-button \nng-click=\"vm.approveOrder(order);\" aria-label=\"Onayla\" class=\"md-raised md-accent green\">Onayla</md-button><md-button \naria-label=\"Sipariş Detayları\" ng-click=\"vm.openOrderDetail(order);\" \nclass=\"md-raised md-accent animated infinite tada\">Sipariş Detayları</md-button><md-button \nng-click=\"vm.refuseOrder(order)\" aria-label=\"Reddet\" class=\"md-raised md-accent red\">Reddet</md-button></div></td></tr>\n<tr class=\"row-end\"><td colspan=\"10\" hide-gt-sm class=\"action-cell\"><div layout-align=\"center center\" \nng-hide=\"vm.isApproveOrRefuseProcessing\"><md-button ng-click=\"vm.approveOrder(order);\" aria-label=\"Onayla\" \nclass=\"md-raised md-accent green\">Onayla</md-button><md-button aria-label=\"Sipariş Detayları\" \nng-click=\"vm.openOrderDetail(order);\" class=\"md-raised md-accent animated infinite tada\">Sipariş Detayları</md-button>\n<md-button ng-click=\"vm.refuseOrder(order)\" aria-label=\"Reddet\" class=\"md-raised md-accent red\">Reddet</md-button>\n</div></td></tr></tbody></table></div>");
$templateCache.put("app/main/branchOrders/pakettaxi.html","");
$templateCache.put("app/main/branchOrders/status-menu.html","<div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-menu \nng-if=\"\'QyKAwUxuhGXOtl49Opajp4KVeCJ3\' === firebaseUser.uid\" md-position-mode=\"left bottom\"><md-button \nclass=\"md-raised\" ng-click=\"$mdMenu.open()\"><i class=\"icon s24 icon-store\"></i>\n {{vm.smallBranchObj.appName}} - {{vm.smallBranchObj.name}} <i class=\"icon s24 icon-chevron-down\" \nng-hide=\"vm.masterStatus === -1\"></i><div ng-show=\"vm.masterStatus === -1\"><span class=\"text-boxed passive\">\nSipariş Sistemi: KAPALI</span></div><div ng-if=\"vm.masterStatus !== -1\"><span class=\"text-boxed green\" \nng-show=\"vm.branchStatus === 1\">Sipariş Sistemi: AÇIK </span><span class=\"text-boxed red\" \nng-show=\"vm.branchStatus === -1\">Sipariş Sistemi: KAPALI </span><span class=\"text-boxed orange\" \nng-show=\"vm.branchStatus === -2\">Sipariş Sistemi: MEŞGUL</span></div></md-button><md-menu-content><md-menu-item \nclass=\"md-indent\"><md-button ng-click=\"vm.setStatusOpen();\" class=\"md-accent green\">Sipariş Sistemi: AÇIK</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-button \nng-click=\"vm.setStatusClosed();\" class=\"md-accent red\">Sipariş Sistemi: KAPALI</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-button ng-click=\"vm.setStatusBusy();\" \nclass=\"md-accent orange\">Sipariş Sistemi: MEŞGUL</md-button></md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item class=\"md-indent\"><md-button ng-click=\"vm.setMasterStatusOpen();\" class=\"\">Master Sistem Açık</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-button \nng-click=\"vm.setMasterStatusClose();\" class=\"\">Master Sistem Kapalı</md-button></md-menu-item></md-menu-content>\n</md-menu><md-menu ng-show=\"\'QyKAwUxuhGXOtl49Opajp4KVeCJ3\' !== firebaseUser.uid\" md-position-mode=\"left bottom\">\n<md-button class=\"md-raised\" ng-disabled=\"vm.masterStatus === -1\" ng-click=\"$mdMenu.open()\"><i \nclass=\"icon s24 icon-store\"></i> {{vm.smallBranchObj.appName}} - {{vm.smallBranchObj.name}} <i \nclass=\"icon s24 icon-chevron-down\" ng-hide=\"vm.masterStatus === -1\"></i><div ng-show=\"vm.masterStatus === -1\"><span \nclass=\"text-boxed passive\">Sipariş Sistemi: KAPALI</span></div><div ng-if=\"vm.masterStatus !== -1\"><span \nclass=\"text-boxed green\" ng-show=\"vm.branchStatus === 1\">Sipariş Sistemi: AÇIK </span><span class=\"text-boxed red\" \nng-show=\"vm.branchStatus === -1\">Sipariş Sistemi: KAPALI </span><span class=\"text-boxed orange\" \nng-show=\"vm.branchStatus === -2\">Sipariş Sistemi: MEŞGUL</span></div></md-button><md-menu-content><md-menu-item \nclass=\"md-indent\"><md-button ng-click=\"vm.setStatusOpen();\" class=\"md-accent green\">Sipariş Sistemi: AÇIK</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-button \nng-click=\"vm.setStatusClosed();\" class=\"md-accent red\">Sipariş Sistemi: KAPALI</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-button ng-click=\"vm.setStatusBusy();\" \nclass=\"md-accent orange\">Sipariş Sistemi: MEŞGUL</md-button></md-menu-item></md-menu-content></md-menu><md-button \nng-hide=\"isAutocallLead\" class=\"md-button md-raised\" ng-click=\"vm.showNotificationSettings($event);\"><md-icon \nmd-font-icon=\"icon-bell-ring\"></md-icon>Ayarlar</md-button></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>HY\n</span></div><div class=\"title\">Otomatik sipariş yazdırma yazılımına Hoşgeldiniz</div><div class=\"subtitle\">\nBu yazılımla<br>Siparişlerin otomatik olarak yazılmasını sağlar,<br>görüntüler, onaylar, bildirimler alabilirsiniz.\n</div><div class=\"subtitle\">Cep telefonu numaranızla giriş yapın</div><form name=\"vm.loginForm\" novalidate>\n<md-input-container class=\"md-icon-float md-block\" ng-if=\"!vm.isSmsPasswordInputVisible\"><label>Cep Telefonu Numarası\n</label><input name=\"mobilePhone\" autofocus md-autofocus ng-model=\"vm.form.mobilePhone\" placeholder=\"5XXXXXXXXX\" \nng-pattern=\"/^5[0-9]{9}$/\" md-maxlength=\"10\" required><div ng-messages=\"vm.loginForm.mobilePhone.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Gerekli</span></div><div ng-message=\"pattern\"><span>\nKabul edilen numara 5 ile başlamalı Başında 0 olmamalı ve 10 haneli olmalıdır (5XXXXXXXXX)</span></div><div \nng-message=\"md-maxlength\"><span>Numarayı başında 0 olmadan yazın</span></div></div></md-input-container><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\" ng-if=\"vm.error\"><span class=\"error md-warn-bg p-10\">\n{{ vm.error }}</span></div><div class=\"text-right\" ng-if=\"!vm.isSmsPasswordInputVisible\"><div ng-if=\"vm.isLoading\" \nclass=\"loading md-background-bg\" layout=\"column\" layout-align=\"center center\"><md-progress-circular class=\"md-warn\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></div><md-button ng-if=\"!vm.isLoading\" type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"SMS Şifresi gönder\" ng-click=\"vm.sendMeVerificationCode()\" \nng-disabled=\"vm.loginForm.$invalid || vm.loginForm.$pristine || vm.isLoading\">SMS Şifresi gönder</md-button></div><div \nng-if=\"vm.isSmsPasswordInputVisible\" class=\"font-size-15\"><p>30 saniye içinde bir SMS şifresi <strong>\n{{vm.form.mobilePhone}}</strong> telefonunuza gelmiş olacak. Bu şifreyi aşağıdaki kutucuğa yazınız.</p></div><div \nng-if=\"vm.isSmsPasswordInputVisible\" class=\"p-20 text-center\"><md-button aria-label=\"Yeniden SMS şifresi gönder\" \nng-click=\"vm.sendMeVerificationCode()\" ng-disabled=\"vm.isLoading\">Yeniden SMS şifresi gönder</md-button></div>\n<md-input-container class=\"md-icon-float md-block\" ng-if=\"vm.isSmsPasswordInputVisible\"><label>SMS Şifresi</label>\n<input id=\"smsPasswordInput\" autofocus md-autofocus name=\"smsPassword\" ng-model=\"vm.form.smsPassword\" \nplaceholder=\"XXXX\" ng-pattern=\"/[0-9]{4}$/\" md-maxlength=\"4\" required><div \nng-messages=\"vm.loginForm.smsPassword.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nTelefonunuza gelen SMS şifresini girmelisiniz</span></div><div ng-message=\"pattern\"><span>SMS şifresi 4 rakamdan oluşur\n</span></div><div ng-message=\"md-maxlength\"><span>SMS şifresi 4 rakamdan daha uzun olamaz.</span></div></div>\n</md-input-container><div class=\"text-right\" ng-if=\"vm.isSmsPasswordInputVisible\"><div ng-if=\"vm.isLoading\" \nclass=\"loading md-background-bg\" layout=\"column\" layout-align=\"center center\"><md-progress-circular class=\"md-warn\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></div><md-button type=\"submit\" ng-if=\"!vm.isLoading\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"SMS şifresini gönder\" ng-click=\"vm.verifySmsCode()\" \nng-disabled=\"vm.loginForm.$invalid || vm.loginForm.$pristine || vm.isLoading\">SMS şifresini gönder</md-button></div>\n</form><hr><md-button class=\"md-button md-raised\" ng-click=\"vm.openEmailLoginModal($event);\">\nEmail ve şifre ile giriş yap</md-button><hr></div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Kapat\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/branchList/branchAutoPrintSettings/branchAutoPrintSettings-dialog.html","<md-dialog class=\"branchAutoPrintSettings-dialog\" aria-label=\"branchAutoPrintSettings\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Otomatik Yazdırma Seçenekleri</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Kapat\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form \nname=\"vm.printerSettingsForm\" novalidate><md-dialog-content class=\"md-background-bg\" layout-align=\"center center\" \nlayout=\"column\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" ng-show=\"vm.isLoading\">\n<md-progress-circular class=\"md-warn\" md-diameter=\"32\" md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-hide=\"vm.isLoading\">{{vm.branch.appName}} - {{vm.branch.name}}<br><br><div ng-if=\"vm.printers.length === 0\"><div \nclass=\"md-warn-bg p-10\">0 yazıcı</div></div><div ng-if=\"vm.printers.length > 0\"><div>\nYazdırmak istediğiniz işletmeyi seçin ve yazıcı cihaz ayarlarını yapın</div><div><md-switch \nng-model=\"vm.branchSettings.enabled\" aria-label=\"Auto-print enable/disable\">Otomatik yazdırma</md-switch><div \nng-show=\"vm.branchSettings.enabled\">Yazıcı:<md-input-container><md-select aria-label=\"printer\" required \nname=\"printerDeviceName\" ng-model=\"vm.branchSettings.printerDeviceName\"><md-option value=\"{{printer.deviceName}}\" \nng-repeat=\"(index, printer) in vm.printers\">{{printer.deviceName}}</md-option></md-select><div \nng-messages=\"vm.printerSettingsForm.printerDeviceName.$error\" role=\"alert\"><div ng-message=\"required\"><span>Gerekli\n</span></div></div></md-input-container><br><br>Kağıt tipi:<md-input-container><md-select aria-label=\"printer\" \nrequired name=\"paperType\" ng-model=\"vm.branchSettings.paperType\"><md-option value=\"{{key}}\" \nng-repeat=\"(key, paper) in vm.paperTypes\">{{paper}}</md-option></md-select><div \nng-messages=\"vm.printerSettingsForm.paperType.$error\" role=\"alert\"><div ng-message=\"required\"><span>Gerekli</span>\n</div></div></md-input-container><br><br>Yazı büyüklüğü:<md-input-container><md-select aria-label=\"font\" required \nname=\"font\" ng-model=\"vm.branchSettings.font\"><md-option value=\"{{key}}\" ng-repeat=\"(key, name) in vm.fontTypes\">\n{{name}}</md-option></md-select><div ng-messages=\"vm.printerSettingsForm.font.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Seç</span></div></div></md-input-container><br><md-switch \nng-model=\"vm.branchSettings.playSound\" aria-label=\"playSound enable/disable\">Sesli uyarı yap</md-switch><br>\n<md-input-container><label>Kaç tane kopya çıkarılsın</label><input \nng-change=\"vm.onNumberOfCopiesChanged(vm.branchSettings.numberOfCopies)\" name=\"numberOfCopies\" ng-min=\"0\" min=\"0\" \ntype=\"number\" ng-model=\"vm.branchSettings.numberOfCopies\" placeholder=\"1\"></md-input-container><br></div></div></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" ng-hide=\"vm.isLoading\" layout-align=\"end center\"><div \nlayout=\"row\"><md-button ng-click=\"vm.save()\" ng-disabled=\"vm.printerSettingsForm.$invalid || vm.isLoading\" \ntype=\"submit\" class=\"md-primary md-raised\" aria-label=\"Kaydet\">Kaydet</md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/dialogs/loading-dialog/loading-dialog.html","<md-dialog class=\"loading-dialog\" aria-label=\"Yükleniyor\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nYükleniyor</span></div></md-toolbar><md-dialog-content class=\"md-background-bg\" layout-align=\"center center\" \nlayout=\"column\"><div><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular></div><div>Lütfen bekleyin</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialogs/notificationMobileSettings/notificationMobileSettings-dialog.html","<md-dialog class=\"notificationMobileSettings-dialog\" aria-label=\"Ayarlar\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Ayarlar</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Kapat\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" layout-align=\"center center\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\" ng-show=\"vm.isLoading\"><md-progress-circular class=\"md-warn\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-hide=\"vm.isLoading\"><div>\nSipariş geldiğinde mobil uygulamaya otomatik bildirimler gelir.<br>Bu bildirimleri buradan açıp kapatabilirsiniz.</div>\n<div><md-switch ng-repeat=\"(key, branchNotification) in vm.branchsNotificationList\" \nng-change=\"vm.onNotificationChanged(key, branchNotification);\" ng-model=\"branchNotification.isSubscribed\" \naria-label=\"mobil bildirim\">{{branchNotification.appName}} - {{branchNotification.name}}</md-switch></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialogs/notificationSettings/notificationSettings-dialog.html","<md-dialog class=\"notificationSettings-dialog\" aria-label=\"Ayarlar\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAyarlar</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Kapat\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nlayout-align=\"center center\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" ng-show=\"vm.isLoading\">\n<md-progress-circular class=\"md-warn\" md-diameter=\"32\" md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-hide=\"vm.isLoading\" class=\"tables\"><h1>{{vm.smallBranchObj.appName}} - {{vm.smallBranchObj.name}}</h1><h2>\nEğer siparişe hemen yanıt vermezseniz 5 dk içinde bir SMS ve otomatik arama alırsınız.</h2><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.playNotification()\">Otomatik aramayı dinle<md-icon \nng-if=\"!vm.isAudioPlaying\" md-font-icon=\"icon-play-circle\" class=\"s32\"></md-icon><md-icon ng-if=\"vm.isAudioPlaying\" \nmd-font-icon=\"icon-stop\" class=\"s32\"></md-icon></md-button><div class=\"numbers\"><h3>\nSipariş bildirimini Otomatik Çağrı olarak almak istediğiniz numaralar:</h3><div class=\"row\" layout=\"row\" \nng-show=\"vm.primaryNumber.number\" layout-align=\"start center\"><md-button aria-label=\"sil\" \nng-click=\"vm.showDeletePrimaryWarning();\" class=\"md-raised md-icon-button md-warn\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button><span>{{vm.primaryNumber.number}}</span></div><div \nng-repeat=\"(key, numberObj) in vm.phoneNumbers\" class=\"row\" layout=\"row\" layout-align=\"start center\"><md-button \naria-label=\"sil\" ng-click=\"vm.deletePhoneNumber(numberObj.number);\" class=\"md-raised md-icon-button md-warn\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button><span>{{numberObj.number}}</span></div><div layout=\"row\" \nlayout-xs=\"column\" layout-align-xs=\"start center\" layout-align=\"start center\"><md-button \naria-label=\"telefon numarası ekle\" ng-click=\"vm.isPhoneInputVisible=!vm.isPhoneInputVisible\" \nclass=\"md-raised md-icon-button md-accent\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><form \nname=\"vm.formPhone\" novalidate><div ng-show=\"vm.isPhoneInputVisible\" layout=\"row\" layout-align=\"start start\">\n<md-input-container class=\"md-icon-float md-block\"><label>Telefon numarası</label><input name=\"phoneNumber\" autofocus \nmd-autofocus ng-model=\"vm.phoneFormModel.phoneNumber\" placeholder=\"2125554433\" ng-pattern=\"/^[0-9]{10}$/\" \nmd-maxlength=\"10\" required><div ng-messages=\"vm.formPhone.phoneNumber.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Gerekli </span></div><div ng-message=\"pattern\"><span>\nKabul edilen numara 2123334455 şeklindedir </span></div><div ng-message=\"md-maxlength\"><span>\nNumarayı başında 0 olmadan yazın</span></div></div><div class=\"note\"><span>Sabit hat ya da cep numarası yazabilirsiniz.\n</span></div></md-input-container><md-button type=\"submit\" \nng-disabled=\"vm.formPhone.$invalid || vm.formPhone.$pristine\" class=\"md-button md-raised md-primary save-btn\" \nng-click=\"vm.addPhoneNumber();\">Kaydet</md-button></div></form></div></div><br><hr><br><div class=\"numbers\"><h3>\nSipariş bildirimini SMS olarak almak istediğiniz numaralar</h3><div class=\"row\" layout=\"row\" \nng-show=\"vm.primarySms.number\" layout-align=\"start center\"><md-button aria-label=\"sil\" \nng-click=\"vm.showDeletePrimaryWarning();\" class=\"md-raised md-icon-button md-warn\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button><span>{{vm.primarySms.number}}</span></div><div ng-repeat=\"(key, numberObj) in vm.smsNumbers\" \nclass=\"row\" layout=\"row\" layout-align=\"start center\"><md-button aria-label=\"sil\" \nng-click=\"vm.deleteSmsNumber(numberObj.number);\" class=\"md-raised md-icon-button md-warn\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button><span>{{numberObj.number}}</span></div><div layout=\"row\" \nlayout-xs=\"column\" layout-align-xs=\"start center\" layout-align=\"start center\"><md-button \naria-label=\"Add new sms number\" ng-click=\"vm.isSmsInputVisible=!vm.isSmsInputVisible\" \nclass=\"md-raised md-icon-button md-accent\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><form \nname=\"vm.formSms\" novalidate><div ng-show=\"vm.isSmsInputVisible\" layout=\"row\" layout-align=\"start start\">\n<md-input-container class=\"md-icon-float md-block\"><label>Cep Telefonu Numarası</label><input name=\"smsNumber\" \nautofocus md-autofocus ng-model=\"vm.smsFormModel.smsNumber\" placeholder=\"5XXXXXXXXX\" ng-pattern=\"/^5[0-9]{9}$/\" \nmd-maxlength=\"10\" required><div ng-messages=\"vm.formSms.smsNumber.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Gerekli </span></div><div ng-message=\"pattern\"><span>\nKabul edilen numara 5 ile başlamalı Başında 0 olmamalı ve 10 haneli olmalıdır (5XXXXXXXXX)</span></div><div \nng-message=\"md-maxlength\"><span>Numarayı başında 0 olmadan yazın</span></div></div><div class=\"note\"><span>\nCep telefonu numarası girin</span></div></md-input-container><md-button type=\"submit\" \nng-disabled=\"vm.formSms.$invalid || vm.formSms.$pristine\" class=\"md-button md-raised md-primary save-btn\" \nng-click=\"vm.addSmsNumber();\">Kaydet</md-button></div></form></div></div><div ng-show=\"global.GLOBAL_EMBEDDED_EXPO\">\n<md-switch ng-change=\"vm.onMobileNotificationChanged(vm.expoTokenObj.isSubscribed);\" \nng-model=\"vm.expoTokenObj.isSubscribed\" aria-label=\"mobil bildirim\">Mobil uygulama bildirimleri</md-switch></div></div>\n<br><md-divider></md-divider><br><div ng-if=\"!vm.isLoading\">Bildirim sesini değiştir<md-input-container><md-select \nrequired name=\"soundOption\" ng-model=\"vm.soundOption\" ng-change=\"vm.onSoundOptionChanged(vm.soundOption);\" \nplaceholder=\"Bir bildirim sesi seçin\"><md-option value=\"0\">Zil</md-option><md-option value=\"{{key}}\" \nng-repeat=\"(key, sound) in vm.globalAudioObj\">{{key}}</md-option></md-select></md-input-container></div><br>\n<md-divider></md-divider><br></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialogs/passwordUpdate/passwordUpdate-dialog.html","<md-dialog class=\"password-update-dialog\" aria-label=\"Şifre ekle/değiştir\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Şifre ekle/değiştir</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Kapat\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form \nname=\"passwordUpdateForm\" novalidate><md-dialog-content class=\"md-background-bg\" layout-align=\"center center\"><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\" ng-if=\"vm.error\"><span class=\"error md-warn-bg p-10\">\n{{ vm.error }}</span></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" \nng-if=\"vm.form.password !== vm.form.password2\"><span class=\"error md-warn-bg p-10\">Şifreler uyuşmuyor</span></div><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\" ng-show=\"vm.isLoading\"><md-progress-circular \nclass=\"md-warn\" md-diameter=\"32\" md-mode=\"indeterminate\"></md-progress-circular></div><md-input-container \nclass=\"md-icon-float md-block\"><label>Şifre</label><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nrequired><div ng-messages=\"passwordUpdateForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nŞifre gerekli</span></div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>\nŞifre(tekrar)</label><input type=\"password\" name=\"password2\" ng-model=\"vm.form.password2\" required><div \nng-messages=\"passwordUpdateForm.password2.$error\" role=\"alert\"><div ng-message=\"required\"><span>Gerekli</span></div>\n</div></md-input-container></md-dialog-content><md-dialog-actions class=\"md-background-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"space\"></div><div layout=\"row\"><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"Gönder\" ng-click=\"vm.updatePassword()\" \nng-disabled=\"passwordUpdateForm.$invalid || passwordUpdateForm.$pristine || vm.isLoading || vm.form.password !== vm.form.password2\">\nGönder</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dialogs/showHtml-dialog/showhtml-dialog.html","<md-dialog class=\"show-html-dialog\" aria-label=\"{{vm.title}}\"><md-toolbar class=\"md-accent\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Kapat\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" \nlayout-align=\"center center\"><ng-bind-html ng-bind-html=\"vm.html\"></ng-bind-html></md-dialog-content></md-dialog>");
$templateCache.put("app/main/login/email-login-dialog/email-login-dialog.html","<md-dialog class=\"email-login-dialog\" aria-label=\"Email ve şifre ile giriş yap\"><md-toolbar class=\"md-accent\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\"><md-icon md-font-icon=\"icon-email\" class=\"s32\"></md-icon>Email ve şifre ile giriş yap</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Kapat\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content class=\"md-background-bg\" layout-align=\"center center\"><form\n name=\"vm.loginForm\" novalidate><div ng-if=\"vm.isLoading\" class=\"loading md-background-bg\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular class=\"md-warn\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" ng-if=\"vm.error\"><span \nclass=\"error md-warn-bg p-10\">{{ vm.error }}</span></div><md-input-container class=\"md-icon-float md-block\"><label>\nEmail</label><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"vm.loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nBir email adresi girmelisiniz</span></div><div ng-message=\"pattern\"><span>Doğru bir email girilmeli</span></div></div>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label>Şifre</label><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" required><div ng-messages=\"vm.loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Şifre gerekli</span></div></div></md-input-container><md-button ng-if=\"!vm.isLoading\" \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"Gönder\" ng-click=\"vm.login()\" \nng-disabled=\"vm.loginForm.$invalid || vm.loginForm.$pristine || vm.isLoading\">Gönder</md-button></form>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s24 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"title icon-check icon s24 icon-checkbox-marked-circle yellow-ok\" ng-if=\"node.isDone\"></i>\n            <i class=\"icon-chevron-right s24 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s24 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"title icon-check icon s24 icon-checkbox-marked-circle yellow-ok\" ng-if=\"node.isDone\"></i>\n            <i class=\"icon-chevron-right s24 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/branchOrderDetails/dialogs/approve-order-dialog/approve-order-dialog.html","<md-dialog class=\"approve-order-dialog\" aria-label=\"approve order\"><md-toolbar class=\"md-primary\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nOnayla</span><md-button ng-hide=\"vm.isLoading\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Kapat\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"md-background-bg\" layout-align=\"center center\"><div layout=\"column\"><div layout=\"row\" \nlayout-align=\"center center\"><md-button ng-click=\"vm.approve(0)\" class=\"md-primary md-raised\" aria-label=\"15\">\nTahmini zaman vermeden onayla</md-button></div><div layout=\"row\"><md-button ng-click=\"vm.approve(15)\" \nclass=\"md-accent md-raised\" aria-label=\"15\">15 dk.</md-button><md-button ng-click=\"vm.approve(30)\" \nclass=\"md-accent md-raised\" aria-label=\"30\">30 dk.</md-button><md-button ng-click=\"vm.approve(45)\" \nclass=\"md-accent md-raised\" aria-label=\"45\">45 dk.</md-button><md-button ng-click=\"vm.approve(60)\" \nclass=\"md-accent md-raised\" aria-label=\"60\">60 dk.</md-button></div><div layout=\"row\"><md-button \nng-click=\"vm.approve(75)\" class=\"md-accent md-raised\" aria-label=\"75\">75 dk.</md-button><md-button \nng-click=\"vm.approve(90)\" class=\"md-accent md-raised\" aria-label=\"90\">90 dk.</md-button><md-button \nng-click=\"vm.approve(105)\" class=\"md-accent md-raised\" aria-label=\"105\">105 dk.</md-button><md-button \nng-click=\"vm.approve(120)\" class=\"md-accent md-raised\" aria-label=\"120\">120 dk.</md-button></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/branchOrderDetails/dialogs/reject-order/reject-order-dialog.html","<md-dialog class=\"reject-order-dialog\" aria-label=\"Sipariş Reddet/iade et\"><md-toolbar class=\"md-warn\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Sipariş Reddet/iade et</span><md-button ng-hide=\"vm.isLoading\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Kapat\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form name=\"vm.rejectOrderForm\" novalidate><md-dialog-content class=\"md-background-bg\" \nlayout-align=\"center center\"><div ng-show=\"vm.isLoading\"><md-progress-circular class=\"md-warn\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular></div><div layout=\"column\" ng-hide=\"vm.isLoading\"><md-input-container>\n<md-select required name=\"reasonCode\" ng-model=\"vm.rejectObj.code\" placeholder=\"Lütfen neden reddettiğinizi seçin\">\n<md-option value=\"{{reasonKey}}\" ng-repeat=\"(reasonKey, reason) in vm.reasons\">{{reason.text}}</md-option></md-select>\n<div ng-messages=\"vm.rejectOrderForm.reasonCode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nBir neden seçilmesi<br>zorunludur</span></div></div></md-input-container><md-input-container><label>Açıklama</label>\n<textarea name=\"reasonText\" ng-model=\"vm.rejectObj.reason\" ng-required=\"vm.rejectObj.code === vm.reasons.OTHER.code\" \nrows=\"3\" max-rows=\"3\"></textarea><div ng-messages=\"vm.rejectOrderForm.reasonText.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Bir açıklama girilmesi<br>zorunludur</span></div></div></md-input-container>\nOnline ödenmiş siparişler otomatik iade edilir</div></md-dialog-content><md-dialog-actions layout=\"row\" \nng-hide=\"vm.isLoading\" layout-align=\"end center\"><div layout=\"row\"><md-button \nng-click=\"vm.rejectButtonAction(vm.rejectObj)\" \nng-disabled=\"vm.rejectOrderForm.$invalid || vm.rejectOrderForm.$pristine || vm.isLoading\" type=\"submit\" \nclass=\"md-primary md-raised\" aria-label=\"REDDET\">REDDET</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);